import React from 'react';
import moment from 'moment';
import { fromJS, List, Map } from 'immutable';
import { compose, is, mergeDeepRight, keys, contains, find,omit, reduceWhile, startsWith, replace,pick } from 'ramda';

import api from '@synergycms_core/utils/api';
import Form from '@synergycms_core/components/generic/Form';
import InputField from '@synergycms_core/components/generic/Form/InputField.jsx';
import CheckboxField from '@synergycms_core/components/generic/Form/CheckboxField.jsx';
import ToggleCheckbox from '@synergycms_core/components/generic/Form/ToggleCheckbox.jsx';
import TextAreaField from '@synergycms_core/components/generic/Form/TextAreaField.jsx';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';
import styleFile from './CustomerForm.js';
import reactSelectStyles from './reactSelectStyles.js';
import Footer from '../../components/functional/Footer/Footer.jsx';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import LoyaltyLogin from '../../components/functional/Loyalty/LoyaltyLogin.jsx';
import AvailMainSideSummary from '../../components/functional/AvailMainSideSummary/AvailMainSideSummary.jsx';
import { AR_STATES, PCI_URL, PROPERTY_MANAGEMENT_GROUP } from '../../config/constants';
import {DOCUMENT_TYPES} from '@synergycms_core/config/constants';
import PciFrame from '../../components/functional/CustomerForm/PciFrame';
import RoomPreferences from '../../components/functional/CustomerForm/RoomPreferences';
import SelectCountry from '@synergycms_core/components/functional/CustomerForm/SelectCountry.jsx';
import SelectField from '@synergycms_core/components/generic/Form/SelectField.jsx';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import connect from 'react-redux/es/connect/connect';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import {
  cleanHotelPreferences,
  getPrepaymentText,
  getReservationTotals,
  addScripts,
  decodeBlackEmail,
  isAppleDevice,
  parseTaxes,
  round,
  shouldShowTaxes,
  getReservationTotalsBothModes,
  applyMandatoryFeeSplit
} from '../../utils';
import { hashSpliter } from '@synergycms_core/utils';
import Price from '@synergycms_core/components/generic/Price';
import { Button, RichText, Image } from '@synergycms_core/components/generic/';
import EPGClass from '@synergycms_core/utils/tpv/epg';
import NemuruClass from '@synergycms_core/utils/tpv/nemuru';
import SibsFrame from '../../components/functional/CustomerForm/SibsFrame';
import RedsysClass from '@synergycms_core/utils/tpv/redsys';
import XpayClass from '@synergycms_core/utils/tpv/xPay';
import AdyenClass from '@synergycms_core/utils/tpv/adyen';
import SibsClass from '@synergycms_core/utils/tpv/sibs';
import PaycometClass from '@synergycms_core/utils/tpv/paycomet';
import CardnetClass from '@synergycms_core/utils/tpv/cardnet';
import WebpayClass from '@synergycms_core/utils/tpv/webpay';
import StripeClass from '@synergycms_core/utils/tpv/stripe';
import PaylandsClass from '@synergycms_core/utils/tpv/paylands';
import WeArePlanetClass from '@synergycms_core/utils/tpv/weArePlanet';
import AmazonClass from '../../utils/tpv/amazon';
import PayPalClass from '../../utils/tpv/paypal';
import SelectPayForm from '../../components/functional/CustomerForm/SelectPayform.jsx';
import actions from '../../store/actions';
import { getPenalties, getPenaltyTimezone, getPenaltyChargebackUSA } from '../../utils/penalties';
import {contextualizeAppConfig} from '@synergycms_core/store/app/utils';
import { hasCancellationFeesIn15Days } from '../../store/customer/reservation/reservationUtils';
import {
  EquivalentPrice,
  OldPrice,
  TaxIncluded,
  LoadingFragment,
  LoadingConfirmation,
  EPGContainer,
  NemuruCheckout
} from '../../components/functional/CustomerForm/SmallComponents';
import PayPalContainer from '../../components/functional/CustomerForm/PayPalContainer.jsx';
import AmazonPayButton from '../../components/functional/CustomerForm/AmazonPayButton.jsx';
import PromotionCodeForm from '../../components/functional/CustomerForm/PromotionCodeForm';
import RadioGroupField from '@synergycms_core/components/generic/Form/RadioGroupField';
import AmazonPayWidget from '../../components/functional/CustomerForm/AmazonPayWidget.jsx';
import PolicyModalGroup from '../../components/functional/CustomerForm/PolicyModalGroup.jsx';
import LoyaltyPoliciesChecks from '../../components/functional/Loyalty/LoyaltyPoliciesChecks.jsx';
import { apiGetter } from '@synergycms_core/utils/api';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { CSSTransition } from 'react-transition-group';
import LoyaltyPaymentPoints from '../../components/functional/Loyalty/LoyaltyPaymentPoints';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import StripeFrame from '../../components/functional/CustomerForm/StripeFrame';
import format from 'string-template';
import LoyaltyUserInfo from '../../components/functional/Loyalty/LoyaltyUserInfo.jsx';
import {STAR_TRAVELER_CODE, FIDELTOUR_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import LoyaltyUserPoints from '../../components/functional/Loyalty/LoyaltyUserPoints.jsx';
import { get, isUsDomain } from 'synergycms_core/src/utils/utils.js';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import LoyaltyForm from '../../components/functional/Loyalty/FidelTour/LoyaltyForm';
import { showPopover } from '@synergycms_core/components/providers/popoverProvider';
import AvailMainSideSummaryTaxes from '../../components/functional/AvailMainSideSummary/Render/AvailMainSideSummaryTaxes.jsx';
import DokuClass from 'synergycms_core/src/utils/tpv/doku';
import AlertBlockPointsModal from '../../components/functional/CustomerForm/AlertBlockPointsModal.jsx';
import Bee2PayClass from '@synergycms_core/utils/tpv/bee2Pay';
import StripeGooglePay from '../../components/functional/CustomerForm/tpv/googlePay/StripeGooglePay';
import AvailMainSideSummaryHotelInfo from '../../components/functional/AvailMainSideSummary/Render/AvailMainSideSummaryHotelInfo.jsx';

const { customer: customerActions } = actions;

const payFormsWithPCI = ['htl', 'ccg'];
const customerPatchFields = [
  'name',
  'surname',
  'email',
  'phone',
  'phone_prefix',
  'hours_arrival',
  'customer_treatment',
  'country',
  'state',
  'nationality',
  'document_type',
  'country_iso_code',
  'notes',
  'GDPR_accepted',
  'GDPR_loyalty',
  'check_loyalty',
  'required_policies',
  'tax_number',
  'identity_document',
  'travel_reason',
  'td',
  'tds',
  'tdd',
  'tdf',
  'td_history',
  'POS',
  'chosen_currency',
  'trv_reference',
  'card_holder',
  'travelclub_card',
  'allow_loyalty_point_redemption',
  'addressLine1',
  'customerCountry',
  'customerCity',
  'postCode',
  'booker_name',
  'booker_surname',
  'booker_email',
  'invoice_name',
  'invoice_document_type',
  'invoice_tax_number',
  'invoice_address',
  'invoice_city',
  'invoice_postCode',
  'invoice_country',
  'invoice_email',
];
const bookingPatchFields = customerPatchFields.slice().concat('status', 'payment');

// Tipos de documento de factura para España. Referencia ESTABLE: si se recrea en cada
// render, SelectField (verifyInListSelected) la detecta como lista nueva y resetea el
// valor en bucle (getDerivedStateFromProps + componentDidUpdate).
const INVOICE_DOCUMENT_TYPES = [
  { value: 'NIF' },
  { value: 'NIE' },
  { value: 'DNI' }
];

const ArrivingHoursOptions = (hours, classes) => props => {
  return (
    <div {...props.innerProps} className={classes.textContainer}>
      <div className={classes.nameType}>
      </div>
      <div className={[classes.padded, classes.tipeRoom, 'capitalize'].join(' ')}>
        <RichText innerStyle={['roboto13Black']} text={props.data.label} translate={true} ucFirst={true} />
      </div>
    </div>
  );
};

const CustomerForm = class CustomerForm extends React.Component {
  static displayName = 'CustomerForm';
  /** @type {boolean | string} */
  tpvEnabled = false;
  /** @type {boolean} */
  payPalEnabled = false;
  /** @type {boolean} */
  validForm = false;
  /** @type {boolean} */
  amazonPayEnabled = false;
  /** @type {boolean} */
  nemuruEnabled = false;
  /** @type {AMAZON} */
  Amazon = null;
  /** @type {PAYPAL} */
  PayPal = null;
  /** @type {EPGClass|null } */
  EPG = null;
  Nemuru = null;
  /** @type {string | null} */
  paymentToken = null;
  /** @type {string | null} */
  selectedCountry = null;
  /** @type {string} */
  formID = 'customerBookingForm';
  /** @type {array} */
  errors = [];
  /** @type {number} */
  retriesTpv = 0;
  /** @type {boolean} */
  returnFromSuccessCof = false;
  /** @type {string} */
  tpvBizumRedsys = '0';
  /** @type {string|boolean} */
  tpvApplePayRedsys = false;
  /** @type {string} */
  GtmId = 'td-d3-confirm-form-00';
  /** @type {boolean} */
  travelClubCard = false;
  /** @type {boolean} */
  travelClubEnabled = false;
  /** @type {boolean} */
  stripeTokenRetrieved = false;
  /** @type {string | boolean} */
  altCurrency = false;

  /**
   * Almacena el resultado de loadStripe
   * @type {null}
   */
  cachedStripePromise = null;

  /**
   * Almacena el token generado para el metodo de pago
   * @type {null}
   */
  cachedStripeKey = null;

  constructor(props) {
    super(props);
    const {
      blocks,
      reservation,
      countries,
      tpvPaymentStatus,
      showConfirmation,
      showErrorNotification,
      hotel,
      setReservationPayed,
      triggerEvent,
      incrementPaymentRetry,
      hideAvailEngine,
      referer,
      managementGroupID,
      langCode,
      setStripeToken,
      stripeTokenStatus,
      loyaltyUser,
      loyaltyType,
      loyaltyRoomsAvail,
      loyaltySelected,
      forceOP,
      customerCountry
    } = this.props.config;

    hideAvailEngine();
    const UserLoggedST = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;

    this.travelClubEnabled = hotel.getIn(['travelclub'],false);
    this.tpvEnabled = !(hotel.getIn(['tpv_only_gift_voucher'], false)) ? hotel.getIn(['tpv', 'name'], false) : false;

    this.tpvParams = hotel.getIn(['tpv', 'tpv_params'], false);
    this.tpvEnabledType = this.tpvEnabled === 'Redsys' && this.tpvParams.find(p => p.get('code') === 'Ds_Merchant_type', Map()).get('value', '');
    this.payPalEnabled = hotel.getIn(['paypal', 'name'], false);
    this.amazonPayEnabled = hotel.getIn(['amazon_pay', 'name'], false);
    const redsysBizumParam = this.tpvEnabled === 'Redsys' && this.tpvParams.find(p => p.get('code') === 'bizum_enabled', Map());
    const applePayParam = this.tpvEnabled === 'EPG' && this.tpvParams.find(p => p.get('code') === 'apple_pay', Map());
    const redsysApplePayParam = this.tpvEnabled === 'Redsys' && this.tpvParams.find(p => p.get('code') === 'apple_pay', Map());
    const bizumEpgParam = this.tpvEnabled === 'EPG' && this.tpvParams.find(p => p.get('code') === 'bizum_enabled', Map());
    this.tpvBizumRedsys = redsysBizumParam ? redsysBizumParam.get('value', '') : '0';
    this.tpvBizumEpg = bizumEpgParam ? bizumEpgParam.get('value', '') : false;
    const nemuruTpvParams = hotel.getIn(['nemuru', 'tpv_params'], false);
    this.nemuruEnabled = nemuruTpvParams
      ? nemuruTpvParams.some(param => param?.get('code') === 'agent_id' && param.get('value'))
      : false;
    const enableToggleForm = !!loyaltyUser;
    const showUserInfo = enableToggleForm;
    const showEditUserFields = !enableToggleForm;

    this.tpvApplePay = applePayParam ? applePayParam.get('value','') : false;
    
    this.tpvApplePayRedsys = redsysApplePayParam ? redsysApplePayParam.get('value','') : false;
    const getArea = (key) => {
      return countries.find(country => country.get('alpha2') === reservation.getIn(['customer', key], false)) ||
      countries.find(country => country.get('alpha2') === customerCountry) ||
      ( loyaltyUser && countries.find(country => country.get('alpha2') === loyaltyUser.getIn(['nationality'], false))) ||
      countries.find(country => country.get('alpha2') === this.props.config.defaultCountryCode) ||
      countries.find(country => country.get('alpha2') === 'ES');
    }
    this.altCurrency = this.tpvEnabled === 'EPG' && this.tpvParams.find(p => p.get('code') === 'currency_code')?.get('value','');

    this.repeatedBookingPromise = false;
    this.defaultCountry = this.selectedCountry = getArea("country");
    const nationality = this.defaultNationality = getArea("nationality");
    this.selectedPhone = this.getPhoneFromLoyaltyUser(this.selectedCountry, loyaltyUser);

    const showIdentifierDocument = !!loyaltyRoomsAvail && loyaltySelected && !loyaltyUser && DOCUMENT_TYPES[nationality.get("alpha2")];

    const sendBookingTmsFunction = this.sendBookingTmsFunction;

    //Hora de llegada
    const content = this.props.content
    const arrivingHours = [
      {"value": ''},
      {"value": "08:00 - 09:00"},
      {"value": "09:00 - 10:00"},
      {"value": "10:00 - 11:00"},
      {"value": "11:00 - 12:00"},
      {"value": "12:00 - 13:00"},
      {"value": "13:00 - 14:00"},
      {"value": "14:00 - 15:00"},
      {"value": "15:00 - 16:00"},
      {"value": "16:00 - 17:00"},
      {"value": "17:00 - 18:00"},
      {"value": "18:00 - 19:00"},
      {"value": "19:00 - 20:00"},
      {"value": "20:00 - 21:00"},
      {"value": "21:00 - 22:00"},
      {"value": "22:00 - 23:00"},
      {"value": "23:00 - 00:00"},
      {"value": "00:00 - 01:00"},
      {"value": "01:00 - 02:00"},
    ];

    const customerTreatment = [
      {"value": ''},
      {"value": 'Dr.'},
      {"value": 'Sr.'},
      {"value": 'Sra.'},
      {"value": 'Srta.'},
      {"value": 'Prof.'},
    ];

    this.arrivingHoursList = List(arrivingHours.map( hour => {
      const label = hour.value ? content.t(hour.value) : content.t("_%no lo sé%_")
      return {"value": hour.value, "label": label }
    }))
    this.defaultArrivalHour = this.arrivingHoursList.find(h => h.value === reservation.getIn(['customer', 'hours_arrival'], '' ))

    this.customerTreatmentList = List(customerTreatment.map( prefix => {
      const value = prefix.value ? content.t(prefix.value) : ' '
      return {"value": value, "label": value }
    }))

    this.defaultcustomerTreatment = this.customerTreatmentList.find(p => p.value === reservation.getIn(['customer', 'prefix'], '' ))

    const tpvModel = {
      'PayPal' : PayPalClass,
      'Amazon' : AmazonClass,
      'EPG':EPGClass,
      'SIBS' : SibsClass,
      'REDSYS' : RedsysClass,
      'STRIPE' : StripeClass,
      'PAYCOMET' : PaycometClass,
      'XPAY' : XpayClass,
      'CARDNET' : CardnetClass,
      'Nemuru' : NemuruClass,
      'WEBPAY' : WebpayClass,
      'BEE2PAY' : Bee2PayClass,
      'DOKU' : DokuClass,
      'ADYEN' : AdyenClass,
      'PAYLANDS' : PaylandsClass,
      'WEAREPLANET': WeArePlanetClass
    };

    const initTpv = tpvKey => {
      if(tpvKey) {
        this[tpvKey] = new (tpvModel[tpvKey])({
          environment: process.env.TPV_ENVIROMENT || "prod",
          reservation,
          hotel,
          hotelID: hotel.get('id'),
          tpvPaymentStatus,
          showConfirmation,
          setReservationPayed,
          showErrorNotification,
          incrementPaymentRetry,
          sendBookingTmsFunction, //Solo para paypal porque se ejecuta el proceso antes del onGlobalSubmit
        });
      }
    }

    const tpvKey = this.tpvEnabled?.toUpperCase?.();

    initTpv(tpvKey);

    if (this.amazonPayEnabled) {
      initTpv("Amazon");
    }

    if (this.payPalEnabled){
      initTpv("PayPal");
    }
     if(this.nemuruEnabled){
      initTpv("Nemuru");
    }

    triggerEvent('customer_data');

    const prefilledEmail = reservation.getIn(['customer', 'email'], '');
    if (prefilledEmail) {
      this.props.config.triggerFormEmailEvent(prefilledEmail);
    }

    const showBookerGuestForm =
      reservation.getIn(['customer', 'guest_booker','booker_name'], false) ||
      reservation.getIn(['customer', 'guest_booker','booker_name'], false) ||
      reservation.getIn(['customer', 'guest_booker','booker_email'], false)

    const showInvoiceData = !!reservation.getIn(['customer', 'invoice_data', 'tax_number'], false);
    const invoiceCountryAlpha2 = reservation.getIn(['customer', 'invoice_data', 'country'], false);

    this.state = {
      showIdentifierDocument,
      showInvoiceData,
      invoiceCountryAlpha2,
      showUserInfo,
      showEditUserFields,
      showRoomPreferences:
        blocks &&
        blocks.reduce((showRoomPreferences, block, index) => {
          showRoomPreferences[block.get('idx')] = index === 0;
          return showRoomPreferences;
        }, {}),
      payFormSelected: forceOP ? 'op' :'htl',
      prepayTokenEPG: false,
      showCardValidationError: tpvPaymentStatus === 'COF:ERROR',
      repeatedBooking: {
        status: 'pending',
        email: null,
        clientAccepted: null,
        submited: false
      },
      editCommentary: false,
      showPromotionalBox: false,
      showTravelClub: true,
      heightContainer: 0,
      heightRef: null,
      travelclubError : {
        error : false,
        text: false,
        validCheck: false
      },
      cardHolderError: {
        error : false,
        text: false
      },
      showBookerGuestForm: showBookerGuestForm,
      countrySelectMenuWidth: 0,
      docTypeSelectMenuWidth: 0,
    };

    const paymentToken = reservation && reservation.getIn(['payment', 'token'], false);

    if (typeof paymentToken === 'string') {
      this.paymentToken = paymentToken;
      if (tpvPaymentStatus === 'COF:OK') {
        this.returnFromSuccessCof = true;
      }
    }

    if(this.tpvEnabled === 'Stripe' && stripeTokenStatus) {
      let status = atob(stripeTokenStatus);
      let stripeStatus = status.split(':');
      let tokenStatus = stripeStatus[1] || false;
      let tokenId = stripeStatus[0] || false;
      if( tokenStatus && tokenId) {
        let stripeIntent = tokenId;
        if (typeof tokenStatus === 'string'  && tokenStatus === 'succeeded') {
          this.paymentToken = stripeIntent;
          if (tpvPaymentStatus === 'COF:OK') {
            this.returnFromSuccessCof = true;
          }
        }
      }
    }
    if (this.tpvEnabled === 'Stripe' && !this.paymentToken && !this.returnFromSuccessCof) {
      const pms = hotel && hotel.get('pms');
      const penalties = getPenalties(reservation, managementGroupID === PROPERTY_MANAGEMENT_GROUP, pms, langCode, null, getPenaltyTimezone(hotel), getPenaltyChargebackUSA(hotel));
      const notRefundable = penalties[0].nr || penalties[0].flexible || false;
      const requiredPrepayment = this.props.config.requiredPrepayment;
      const fullFreeReservation = this.props.config.fullFreeReservation;


      this.STRIPE.initialize(
        hotel,
        reservation,
        this.selectedCountry.get('alpha2'),
        this.props.config.langCode.toLowerCase(),
        this.formID,
        this.props.config.currentCurrencyCode,
        showErrorNotification,
        notRefundable ? 'op' : 'htl'
      );
      if(!notRefundable ) {
        const code = hotel.get('code');
        const tracking = reservation.get('tracking_id');
        let url =   document.URL;
        let currency =   this.props.config.currentCurrencyCode;
        let  langCode = this.props.config.langCode.toLowerCase();
        let requiredPrepaymentCalc = 0;
        if (requiredPrepayment > 0 && !fullFreeReservation && !notRefundable ) {
          requiredPrepaymentCalc = requiredPrepayment;

        } else {
          requiredPrepaymentCalc = 0;
        }
        setStripeToken(currency, langCode, requiredPrepaymentCalc, code, tracking, url, true);
        this.stripeTokenRetrieved = true;
      }
    }
    const scripts = hotel.getIn(['extended_scripts'], undefined);
    if (scripts && scripts.size > 0 && referer) {
      addScripts(hotel, referer, 'customer');
    }
    window.addEventListener('message', this.overrideHeight, false);
    window.addEventListener('message', this.hasStoredCards, false);
    if (this.tpvEnabled === 'EPG') {
      window.addEventListener('message', this.EPG.receiveMessage, false);
    }

    if(UserLoggedST) {
      this.tpvEnabled = false;
    }
    this.phoneContainerRef = React.createRef();
    this.documentTypeRef = React.createRef();

    this.paymentModulesStatus = {
      paypal: { loaded: undefined },
      op: { loaded: undefined },
      htl: { loaded: undefined },
      storedCards: undefined
    };
  }

  componentWillUnmount = () => {
    window.removeEventListener('message', this.overrideHeight, false);
    window.removeEventListener('message', this.hasStoredCards, false);
    if (this.tpvEnabled === 'EPG') {
      window.removeEventListener('message', this.EPG.receiveMessage, false);
    }
    if (this.resizeObserver && this.phoneContainerRef.current) {
      this.resizeObserver.unobserve(this.phoneContainerRef.current);
    }
    if (this.resizeObserver && this.documentTypeRef.current) {
      this.resizeObserver.unobserve(this.documentTypeRef.current);
    }
  };

  validateFields = (inputList) => {
    return reduceWhile(
      (validationResult) => {
        return validationResult;
      },
      (validationResult, key) => {
        return !inputList[key].validations.length || get(['validation', 'valid'], inputList[key]) === true;
      },
      true,
      Object.keys(inputList));
  };

  getPhoneFromLoyaltyUser = (selectedCountry, loyaltyUser) => {
    const loyaltyType = this.props.config.loyaltyType
    switch(loyaltyType){
      case STAR_TRAVELER_CODE:
        const phone = loyaltyUser?.get("phone") && replace("+","",loyaltyUser.get("phone"));
        if(phone && selectedCountry?.get('phone_prefix') && startsWith(selectedCountry.get('phone_prefix',''), phone)) {
          return replace(selectedCountry.get('phone_prefix'),"", phone);
        }
        return "";
      case FIDELTOUR_CODE:
        return loyaltyUser && loyaltyUser.get("phone");
      default:
        return "";
    }
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.config.loyaltyUser !== nextProps.config.loyaltyUser) {

      const {
        reservation,
        countries,
        loyaltyUser,
        loyaltyRoomsAvail,
        loyaltySelected,
        customerCountry
      } = nextProps.config;

      const getArea = (key) => {
        return countries.find(country => country.get('alpha2') === reservation.getIn(['customer', key], false)) ||
          countries.find(country => country.get('alpha2') === customerCountry) ||
          ( loyaltyUser && countries.find(country => country.get('alpha2') === loyaltyUser.getIn(['nationality'], false))) ||
          countries.find(country => country.get('alpha2') === this.props.config.defaultCountryCode) ||
          countries.find(country => country.get('alpha2') === 'ES');
      }
      const nationality = this.defaultNationality = getArea("nationality");
      const showIdentifierDocument = !!loyaltyRoomsAvail && loyaltySelected && !loyaltyUser && DOCUMENT_TYPES[nationality.get("alpha2")];
      const {inputList, onGlobalChange} = this.stateRetriever();
      if(inputList && loyaltyUser) {
        const selectedCountry = countries.find(country => country.get('alpha2') === loyaltyUser.getIn(['nationality'], false));
        if(selectedCountry) {
          this.selectedCountry = selectedCountry;
          this.selectedPhone = this.getPhoneFromLoyaltyUser(this.selectedCountry, loyaltyUser);
        }

        const fields = ["name", "surname", "email", "repeatEmail", "phone", "country"];

        Promise.props({
          "name": inputList["name"].onChange(loyaltyUser.get("name"),true),
          "surname": inputList["surname"].onChange(loyaltyUser.get("surname"),true),
          "email": inputList["email"].onChange(loyaltyUser.get("email"),true),
          "repeatEmail": inputList["repeatEmail"].onChange(loyaltyUser.get("email"),true),
          "phone": inputList["phone"].onChange(this.selectedPhone, true),
          "country": inputList["country"].onChange(this.selectedCountry, true)
        }).then(()=> {
          onGlobalChange(fields, null, true).then((inputList)=>{
              const isValid = this.validateFields(pick(fields, inputList));
              const enableToggleForm = isValid && !!loyaltyUser;
              const showUserInfo = enableToggleForm;
              const showEditUserFields = !enableToggleForm;
              this.setState({ showUserInfo, showEditUserFields, showIdentifierDocument });
              this.checkFormEmailEvent(inputList);
          });
            //});
        });
      } else {
        const enableToggleForm =!!loyaltyUser;
        const showUserInfo = enableToggleForm;
        const showEditUserFields = !enableToggleForm;
        this.setState({ showUserInfo, showEditUserFields, showIdentifierDocument });
      }
    }
  }

  validateBlockPoints = () => {
    const {toggleModal, refreshBlockPoints } = this.props.config;

    const {inputList } = this.stateRetriever();
    const value = inputList["allow_loyalty_point_redemption"]?.value;

    return new Promise((resolve, reject)=> {
      if (!value) {
        return resolve();
      }

      refreshBlockPoints().then((serverBlock) => {
        if(serverBlock.success === false) {
          toggleModal(true, "alertBlockPoints",
          <AlertBlockPointsModal
            checkboxChange={(value)=> {
              inputList["allow_loyalty_point_redemption"].onChange(value);
              value ? resolve() : reject(Error("block_points"));
            }}
            closeModal={()=> toggleModal(false, "alertBlockPoints")}
            />);
        } else {
          resolve();
        }
      });

    });
  };

  sendBookingTmsFunction = () => {
    return this.validateBlockPoints().then(() => {
      const {inputList } = this.stateRetriever();
      const value = inputList["allow_loyalty_point_redemption"]?.value;
      if(value) {
        return this.props.config.setBookingTms();
      }
      return Promise.resolve();
    })
  }

  validateRepeatBooking = (inputList, reservation) => {
    const { repeatedBooking } = this.state;
    const { hotel } = this.props.config;

    if (
      !this.repeatedBookingPromise && (
        (repeatedBooking.email !== inputList['repeatEmail'].value && inputList['repeatEmail'].validation.valid) ||
        repeatedBooking.status === 'failed'
      )
    ) {
      this.repeatedBookingPromise = new Promise(resolve => {
        const extraHeaders = [
          { Authorization: 'Basic ' + btoa(reservation.get('tracking_id') + ':' + reservation.get('pin_code')) }
        ];
        api
          .get('cms/check_reservation_duplicated/' + reservation.get('tracking_id'), {}, hotel.get('id'), extraHeaders)
          .then(result => {
            this.setState(
              state => {
                return {
                  repeatedBooking: {
                    ...state.repeatedBooking,
                    status: result.duplicated ? 'repeated' : 'accepted',
                    email: inputList['email'].value,
                    clientAccepted: null,
                    submited: false
                  }
                };
              },
              () => resolve()
            );
          })
          .catch(result => {
            this.setState(
              state => {
                return {
                  repeatedBooking: {
                    ...state.repeatedBooking,
                    status: 'failed',
                    email: inputList['email'].value,
                    clientAccepted: null
                  }
                };
              },
              () => resolve()
            );
          });
      });
      return this.repeatedBookingPromise;
    }
    return Promise.resolve();
  };

  validateTravelclubCard = (valid, inputList, reservation) => {

    const { hotel } = this.props.config;
    let error = false;
    let text = false;
    let validCheck = false;
    if (
        inputList['travelclub_card'] && inputList['travelclub_card']['value'] !== ""
    ) {

      const travelclubCard = inputList['travelclub_card']['value'];
      const reg = /^\d+$/;
      let isNumber = reg.test(String(travelclubCard).toLowerCase());
      if(travelclubCard.length !== 0 && (travelclubCard.length !== 10 || !isNumber)) {
        error = true;
        validCheck = false;
        if(!isNumber) {
          text = '_%el campo tiene que ser un número%_';
        } else {
          text = '_%el campo debe tener 10 dígitos%_';
        }
      } else {
        this.validateTravelClubPromise = new Promise(resolve => {
          const extraHeaders = [
            { Authorization: 'Basic ' + btoa(reservation.get('tracking_id') + ':' + reservation.get('pin_code')) }
          ];
          api
            .post('travelclub_validation', {
              'card': travelclubCard,
              'card_prefix': '6015470',
              'tracking': reservation.get('tracking_id')
            }, hotel.get('id'), extraHeaders)
            .then(result => {
              this.travelClubCard = result ? true : false;
              this.setState(
                state => {
                  return {
                    travelclubError: {
                      ...state.travelclubError,
                      error: result ? false : true,
                      text: result? false : '_%tarjeta no válida%_',
                      validCheck: result
                    }
                  };
                }
              );
            })
            .catch(result => {
              this.travelClubCard = false;
              this.setState(
                state => {
                  return {
                    travelclubError: {
                      ...state.travelclubError,
                      error:  true,
                      text:  '_%tarjeta no válida%_',
                      validCheck: false
                    }
                  };
                }
              );
            });
        });
        return this.validateTravelClubPromise;
      }
    }
    this.setState(
      state => {
        return {
          travelclubError: {
            ...state.travelclubError,
            error: error,
            text: text,
            validCheck: validCheck
          }
        };
      }
    );
    return Promise.resolve();
  };

  validateCardHolder = (valid, inputList) => {

    let error = false;
    let text = false;
    if (
       this.state.payFormSelected === 'htl' && this.tpvEnabled === 'Stripe'
    ) {

      const cardHolder = inputList['card_holder']['value'];

      if(cardHolder.length === 0 ) {
        error = true;
        text = format(this.props.content.t('_%el campo {field} es obligatorio%_'),
          { field: this.props.content.t('_%nombre del titular%_') }
        );
      }
    }
    this.setState(
      state => {
        return {
          cardHolderError: {
            ...state.cardHolderError,
            error: error,
            text: text
          }
        };
      }
    );
    return Promise.resolve();
  };

  componentDidMount(prevProps, prevState, snapshot) {
    //window.frontLoader.render("login-front", { type:"availCustomerForm" });
    //window.frontLoader.renderLogin("login-front", { type:"availCustomerForm" });
    if (this.state.showCardValidationError) {
      this.refs['card_validation_error'].scrollIntoView();
    }

    this.retriesTpv = 0;
    window.onerror = (message, url, line, column, error) => {
      let errorMessage = '';
      if (error) {
        errorMessage = typeof error.stack !== 'undefined' ? error.stack : error.toString();
      }
      errorMessage += ' -> ' + navigator.userAgent;

      this.errors.push({
        url: window.document.location.href,
        message: message,
        error: errorMessage
      });
    };

    this.updateCountrySelectMenuWidth();
    this.updateDocumentMenuWidth();

    this.resizeObserver = new ResizeObserver(() => {
      this.updateCountrySelectMenuWidth();
      this.updateDocumentMenuWidth();
    });

    if (this.phoneContainerRef.current) {
      this.resizeObserver.observe(this.phoneContainerRef.current);
    }
    if (this.documentTypeRef.current) {
      this.resizeObserver.observe(this.documentTypeRef.current);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      hotel,
      loyaltyUser,
      loyaltyType,
      reservation,
      reservationPaid,
      langCode,
      showErrorNotification,
      amountToPay,
      currentCurrencyCode,

    } = this.props.config;

    const UserLoggedST = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;
    const needsSetTPV = !this.tpvEnabled && !(hotel.getIn(['tpv_only_gift_voucher'], false)) && (!UserLoggedST || ['bizum', 'apple'].includes(this.state.payFormSelected)) && hotel.getIn(['tpv', 'name'], false);
    const needsUnsetTPV = this.tpvEnabled && UserLoggedST && !['bizum', 'apple'].includes(this.state.payFormSelected);
    const triggerEventPayment = (!!prevProps.config.loyaltyUser && prevProps.config.loyaltyType === STAR_TRAVELER_CODE) !== UserLoggedST;
    if(needsSetTPV) {
      this.tpvEnabled = hotel.getIn(['tpv', 'name']);
    }
    if(needsUnsetTPV) {
      this.tpvEnabled = false
    }
    if(triggerEventPayment){
      this.paymentModulesStatus.storedCards = UserLoggedST ? this.paymentModulesStatus.storedCards : false;
      this.resolvePaymentEvent(this.state.payFormSelected);
    }

    const refreshBooking = prevProps && (prevProps.config.amountToPay !== amountToPay
    || reservation.get("tracking_id") !== prevProps.config.reservation.get("tracking_id"));

    if (this.tpvEnabled) {
      switch (this.tpvEnabled) {
        case 'EPG':
          if (needsSetTPV || (prevProps && prevProps.config.reservationPaid && !reservationPaid)) {
            this.EPG.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              langCode.toLowerCase(),
              this.formID,
              showErrorNotification,
              this.setStateEPGPrepaymentToken,
              this.checkTpvContainer
            );
          }
          break;
        case 'Redsys':
          if (refreshBooking) {
            this.REDSYS.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              langCode.toLowerCase(),
              this.formID,
              showErrorNotification,
              this.state.payFormSelected
            );
          }
          break;
        case 'Paycomet':
          if (refreshBooking) {
            this.PAYCOMET.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              langCode.toLowerCase(),
              this.formID,
              currentCurrencyCode,
              showErrorNotification
            );
          }
          break;
        case 'xPay':
          if (refreshBooking) {
            this.XPAY.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              langCode.toLowerCase(),
              this.formID,
              currentCurrencyCode,
              showErrorNotification
            );
          }
          break;
        case 'Cardnet':
          if (refreshBooking) {
            this.CARDNET.initialize(
              this.props.config.hotel,
              this.props.config.reservation,
              this.props.config.currentCurrencyCode,
              this.props.config.showErrorNotification
            );
          }
          break;
        case 'Webpay':
          if (prevProps && prevProps.config.amountToPay !== this.props.config.amountToPay) {
            this.WEBPAY.initialize(
              this.props.config.hotel,
              this.props.config.reservation,
              this.props.config.currentCurrencyCode,
              this.props.config.showErrorNotification
            );
          }
          break;
        case 'Stripe':
          if (refreshBooking && this.state.payFormSelected === 'op') {
            this.STRIPE.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              langCode.toLowerCase(),
              this.formID,
              currentCurrencyCode,
              showErrorNotification,
              this.state.payFormSelected
            );
          }
          break;
        case 'Adyen':
          if (refreshBooking) {
            this.ADYEN.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              langCode.toLowerCase(),
              this.formID,
              currentCurrencyCode,
              showErrorNotification
            );
          }
          break;
        case 'bnpl':
          this.Nemuru.init();
          break;
        default:
          break;
      }
    }
    if (prevState.heightContainer === 'auto' && this.state.heightContainer !== 'auto') {
      this.setState({ heightContainer: '0px' });
    }
  }

  checkTpvContainer = () => {
    const { reservation, hotel, showErrorNotification } = this.props.config;

    setTimeout(() => {
      const failsAlert = 4;
      const stopRetries = 10;
      if (this.tpvEnabled === 'EPG') {
        const submitButtonwindow = document.querySelector('#' + this.EPG.submitButton);
        const submitButtonWindowApplepay = this.state.payFormSelected === 'apple';
        const bizumActive = this.state.payFormSelected === 'bizum';
        if (!submitButtonwindow && !submitButtonWindowApplepay && !bizumActive) {
          this.retriesTpv++;
          if (this.retriesTpv <= stopRetries) {
            this.EPG.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              this.props.config.langCode.toLowerCase(),
              this.formID,
              showErrorNotification,
              this.setStateEPGPrepaymentToken,
              this.checkTpvContainer,
              this.state.payFormSelected
            );
          }
          if (this.retriesTpv === failsAlert) {
            let customError = '';
            if (typeof window.EPGJS === 'undefined') {
              customError += 'EPGJS NOT DEFINED; ';
            }
            if (typeof window.EPGJS_COMM === 'undefined') {
              customError += 'EPGJS_COMM NOT DEFINED; ';
            }
            if (typeof window.EPGJS_STYLE === 'undefined') {
              customError += 'EPGJS_STYLE NOT DEFINED; ';
            }
            if (!this.EPG.panInputLoaded) {
              customError += 'EPG PAN NOT LOADED; ';
            }
            const cashier = document.querySelector('#' + this.EPG.cashierContainer);
            this.errors.unshift({
              url: window.document.location.href,
              message: 'TPV EPG ' + failsAlert + ' fails on initialize with render cashier',
              error: customError + navigator.userAgent + (cashier ? '; HTML EPG: ' + cashier.innerHTML : '')
            });
            api.post('cms/send_avail_error', this.errors, hotel.get('id'));
          }
        } else {
          if (this.retriesTpv >= failsAlert) {
            this.errors.unshift({
              url: window.document.location.href,
              message: '<strong>SUCCESS</strong>: TPV EPG ' + failsAlert + ' fails but solved',
              error: ''
            });
            api.post('cms/send_avail_error', this.errors, hotel.get('id'));
          }
        }
      }
    }, 6000);
  };

  setStateEPGPrepaymentToken = prepayTokenEPG => {
    this.setState(state =>
      mergeDeepRight(state, {
        prepayTokenEPG: prepayTokenEPG
      })
    );
  };

  overrideHeight = e => {
    const message = e.data;
    if (e.origin === PCI_URL && message.indexOf('pci_iframe_with') !== -1) {
      let pciIframeHeight;
      [, pciIframeHeight] = message.split(':');
      pciIframeHeight = parseInt(pciIframeHeight, 10);
      if (!(pciIframeHeight === 0 && this.state.pciIframeHeight > 0)) {
        this.setState({
          pciIframeHeight: pciIframeHeight
        });
      }
    }
  };

  hasStoredCards = e => {
    const {loyaltyUser, loyaltyType } = this.props.config;
    const UserLoggedST = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;
    const message = e.data;

    if (e.origin !== PCI_URL || (message.indexOf('has_stored_cards') === -1 && message.indexOf('pci_iframe_loaded') === -1 && message.indexOf('paypal_button_loaded') === -1)){
      return;
    }

    //agafar info del missatge
    let messageValue, messageType;
    [messageType, messageValue] = message.split(':');
    let value = messageValue === 'true';

    switch (messageType) {
      case 'has_stored_cards':
        this.paymentModulesStatus.storedCards = value;
        break;

      case 'pci_iframe_loaded':
        this.paymentModulesStatus.op.loaded = value;
        this.paymentModulesStatus.htl.loaded = value;
        this.paymentModulesStatus.storedCards = (!UserLoggedST)
          ? false
          : this.paymentModulesStatus.storedCards;
        break;

      case 'paypal_button_loaded':
        this.paymentModulesStatus.paypal.loaded = value;
        this.paymentModulesStatus.storedCards = (!UserLoggedST)
          ? false
          : this.paymentModulesStatus.storedCards;
        break;

      default:
        break;
    }
  };

  async resolvePaymentEvent(payFormCode) {
    const { triggerEventHasStoredCards, loyaltyUser, loyaltyType } = this.props.config;
    const isLogged = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;

    const hasModuleStatus = this.paymentModulesStatus.hasOwnProperty(payFormCode);

    let loadedModuleStatus;
    let storedCards = this.paymentModulesStatus.storedCards;

    if (isLogged) {
      this.paymentModulesStatus.storedCards = undefined;

      const waitStoredCards = this.waitForCondition(
        () => this.paymentModulesStatus.storedCards,
        3000,
        false
      );

      const waitPayformLoaded = hasModuleStatus ? this.waitForLoaded(payFormCode) : Promise.resolve(undefined);

      [storedCards, loadedModuleStatus] = await Promise.all([
        waitStoredCards,
        waitPayformLoaded
      ]);
    } else if (hasModuleStatus) {
      loadedModuleStatus = await this.waitForLoaded(payFormCode);
    }

    triggerEventHasStoredCards(
      'payment',
      storedCards,
      payFormCode,
      hasModuleStatus ? loadedModuleStatus : 'unknown'
    );
  }

  waitForCondition(conditionFn, timeout = 3000, fallback = false, interval = 50) {
    return new Promise(resolve => {
      const start = Date.now();

      const check = () => {
        const result = conditionFn();
        if (result !== undefined) {
          resolve(result);
        } else if (Date.now() - start > timeout) {
          resolve(fallback);
        } else {
          setTimeout(check, interval);
        }
      };

      check();
    });
  }

  waitForLoaded(payFormCode, interval = 50, timeout = 10000) {
    return new Promise((resolve) => {
      const start = Date.now();

      const check = () => {
        const module = this.paymentModulesStatus[payFormCode];

        if (module && typeof module.loaded !== "undefined") {
          resolve(module.loaded);
        } else if (Date.now() - start > timeout) {
          resolve(false);
        } else {
          setTimeout(check, interval);
        }
      };

      check();
    });
  };

  validateLoyaltyUser = (inputList, stateRetriever, fromSubmit) => {
    const { manageLoading } = stateRetriever();

    const { reservation, loyaltyRegister, loyaltyType, loyaltyUser, loyaltySelected } = this.props.config;

    if(loyaltySelected && FIDELTOUR_CODE === loyaltyType && !loyaltyUser && fromSubmit) {

      manageLoading(true);

      const subscribed = inputList["GDPR_loyalty"] ? !inputList["GDPR_loyalty"]["value"] : reservation.getIn(['customer', 'check_loyalty'], false);
      const registerinputs = {
        "name": inputList["name"],
        "surname": inputList["surname"],
        "email": inputList["email"],
        "country": inputList["country"],
        "phone": inputList["phone"],
        "password": inputList["password"],
        "repeatPassword": inputList["repeatPassword"],
        "accept_conditions": inputList["required_policies"],
        "subscribed": subscribed
      }

      return loyaltyRegister(registerinputs).then((response) => {
          return response;
      }).catch((error) => {
        manageLoading(false);
        return Promise.reject("loyalty_register_error");
      });

    }
    return Promise.resolve();
  }

  onSubmitButton = (...args)=> this.onGlobalSubmit({fromSubmit:true})(...args);
  validatePaymentForms = (...args)=> this.onGlobalSubmit({fromSubmit:false})(...args);
  onGlobalSubmit = ({fromSubmit}) => (validForm, inputList, stateRetriever) => {
    const { manageLoading } = stateRetriever();

    const {
      reservation,
      hotel,
      showTaxes,
      setReservationPayed,
      showConfirmation,
      hotelCurrencyCode,
      showErrorNotification,
      triggerEvent,
      reservationPaid,
      fullFreeReservation,
      amazonPayMerchantID,
      confirmBookingOnlyStore,
      confirmBookingTPV
    } = this.props.config;

    const { status, clientAccepted } = this.state.repeatedBooking;
    // scroll to first unvalid
    if (!validForm) {
      const firstUnvalidKey = Object.keys(inputList).find(k => inputList[k].validation.valid === false);
      this.refs[firstUnvalidKey] && this.refs[firstUnvalidKey].scrollIntoView();
      window.scrollBy(0, -65);
      triggerEvent('confirm_error', 'required_fields');
      return Promise.reject(Error("invalid_form"));
    } else {
      triggerEvent('confirm_customer_data')
    }

    return this.validateLoyaltyUser(inputList, stateRetriever, fromSubmit)
    .then(()=>this.validateRepeatBooking(inputList, reservation))
    .then(() => {
      //const { repeatedBooking } = this.state;
      const { promise, resolve, reject } = Promise.withResolvers();
      if (status === 'repeated' && !clientAccepted && this.state.payFormSelected !== 'paypal') {
        this.setState(state => {
          return {
            repeatedBooking: {
              ...state.repeatedBooking,
              submited: true,
              clientAccepted: null
            }
          };
        });
        window.scrollTo(0, 0);
        this.acceptedReapetedBookingPromise = { resolve, reject };
      } else {
        return Promise.resolve();
      }

      return promise.then(() => {
        const { repeatedBooking } = this.state;
        if (contains(repeatedBooking.status, ['accepted', 'failed']) || repeatedBooking.clientAccepted || this.state.payFormSelected === 'paypal') {
          return Promise.resolve();
        }
      })
    })
    .then(()=>this.state.payFormSelected !== 'paypal' && this.sendBookingTmsFunction())
    .then(()=>{
      if(this.state.payFormSelected !== 'bnpl' ) manageLoading(true);
      return new Promise((resolve, reject) => {
        if (reservationPaid || fullFreeReservation || reservation.getIn(['payment', 'payform_code'], false) === 'paylink') {
          this.onSubmit(validForm, inputList, resolve, reject, false);
        } else {
          if(["op","bizum","apple"].includes(this.state.payFormSelected) && this.tpvEnabled) {
            switch (this.tpvEnabled) {
              case 'EPG':
                this.EPG.validatePayment(this.onSubmit, validForm, inputList, resolve, reject);
                break;
              case 'SIBS':
              case 'Bee2Pay':
                  // NOTE: SIBS online payment, works equal as hotel payment
                  const pciFrame = this.pciFrame;
                  this.receiveMessagePCIFunction = this.receiveMessagePCI(validForm, inputList, resolve, reject, stateRetriever);
                  window.addEventListener('message', this.receiveMessagePCIFunction, false);
                  pciFrame.contentWindow.postMessage('submit_pci_form', PCI_URL);
                break;
              case 'Redsys':
              case 'xPay':
              case 'Paycomet':
              case 'Stripe':
              case 'Adyen':
              case 'Cardnet':
              case 'DOKU':
              case 'Paylands':
              case 'WeArePlanet':
              case 'Webpay':
                this.onSubmit(validForm, inputList, resolve, reject);
                break;
              default:
                if(this.tpvEnabled) {
                  reject(Error('not valid form'));
                }
                break;
            }
          } else if(["paypal"].includes(this.state.payFormSelected) && this.payPalEnabled) {
            confirmBookingOnlyStore();
            resolve({ payload: Map({ status: 'confirmed' }) });
          } else if(["amazon_pay"].includes(this.state.payFormSelected) && this.amazonPayEnabled) {
            this.Amazon.initConfirmationFlow(
              hotel.get('id'),
              reservation,
              hotelCurrencyCode,
              amazonPayMerchantID,
              confirmBookingOnlyStore,
              resolve,
              reject
            );
          } else if(['bizum'].includes(this.state.payFormSelected) && this.tpvBizumEpg){
            this.EPG.validatePayment(this.onSubmit, validForm, inputList, resolve, reject);
          } else if (["htlng", "ccng"].includes(this.state.payFormSelected)){
            this.onSubmit(validForm, inputList, resolve, reject);
          } else if (["bnpl"].includes(this.state.payFormSelected)){
            this.Nemuru.createCheckout(
              hotel.get('id'),
              reservation,
              confirmBookingOnlyStore,
              this.onSubmit,
              validForm,
              inputList,
              resolve,
              reject,
              this.props.config.langCode.toLowerCase()
            )
          } else if(this.tpvEnabled === 'Stripe' ) {

            this.STRIPE.initialize(
              this.props.config.hotel,
              this.props.config.reservation,
              this.selectedCountry.get('alpha2'),
              this.props.config.langCode.toLowerCase(),
              this.formID,
              this.props.config.currentCurrencyCode,
              this.props.config.showErrorNotification,
              this.state.payFormSelected
            );
            this.validateCardHolder(validForm,inputList);
            const promise = !this.state.cardHolderError.error ? this.paymentCallback() : Promise.resolve();
            promise.then((result) => {
              !result && reject(Error('not valid form'));
            });

          } else if(["googlePay",].includes(this.state.payFormSelected) &&
            ["Redsys",].includes(this.tpvEnabled)
          ) {
            this.onSubmit(validForm, inputList, resolve, reject);
          }else {
            const pciFrame = this.pciFrame;
            this.receiveMessagePCIFunction = this.receiveMessagePCI(validForm, inputList, resolve, reject, stateRetriever);
            window.addEventListener('message', this.receiveMessagePCIFunction, false);
            pciFrame.contentWindow.postMessage('submit_pci_form', PCI_URL);
          }
        }
      })
    }).then(response => {
      let reservationResponse = response;
      // Paypal incluye el response real dentro de payload
      if(typeof reservationResponse.payload !== 'undefined') {
        reservationResponse = reservationResponse.payload;
      }
      if (reservationResponse && reservationResponse.get('status', false) === 'confirmed') {
        if (!['op', 'bizum', 'apple', 'googlePay'].includes(this.state.payFormSelected) ||
          reservationPaid ||
          (!this.tpvEnabled && !this.tpvApplePay)
        ) {
          if (!!this.tpvEnabled && (this.state.payFormSelected === 'op' || this.state.payFormSelected === 'bizum')) {
            setReservationPayed(reservation, showTaxes);
          }
          this.props.config.showConfirmation(reservation, hotel);
        } else if (this.tpvEnabled === 'EPG' || (this.EPG && ['apple','bizum'].includes(this.state.payFormSelected))) {
          if (this.EPG.prepayToken !== false) {
            // en EPG es fa el pagament després de confirmar la reserva.
            return this.EPG.chargePayment(
              inputList,
              hotel,
              reservation,
              hotelCurrencyCode,
              showTaxes,
              this.selectedCountry.get('alpha2'),
              this.props.config.langCode.toLowerCase(),
              this.formID,
              setReservationPayed,
              showConfirmation,
              showErrorNotification,
              this.setStateEPGPrepaymentToken,
              this.checkTpvContainer,
              manageLoading,
              this.state.payFormSelected
            );
          }
        } else if (this.tpvEnabled === 'SIBS') {
            // Approved without 3DS requirement
            this.SIBS.confirm(reservation, manageLoading, this.setCardValidationError, confirmBookingTPV, hotel, inputList);
        } else if (this.tpvEnabled === 'Redsys') {
            this.REDSYS.validatePayment();
        } else if (this.tpvEnabled === 'xPay') {
            this.XPAY.validatePayment();
        } else if (this.tpvEnabled === 'Cardnet') {
          return this.CARDNET.initialize(
            hotel,
            reservation,
            this.props.config.currentCurrencyCode,
            showErrorNotification
          ).then(() => {
            this.CARDNET.validatePayment();
          });
        } else if (this.tpvEnabled === 'Webpay') {
          return this.WEBPAY.initialize(
            hotel,
            reservation,
            this.props.config.currentCurrencyCode,
            showErrorNotification
          ).then(() => {
              this.WEBPAY.validatePayment();
            });
        } else if (this.tpvEnabled === 'Paycomet') {
          return this.PAYCOMET.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            this.props.config.currentCurrencyCode,
            showErrorNotification
          ).then(() => {
            this.PAYCOMET.validatePayment();
          });

        } else if (this.tpvEnabled === 'Stripe') {
          return this.STRIPE.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            this.props.config.currentCurrencyCode,
            showErrorNotification,
            this.state.payFormSelected
          ).then(() => {
            this.STRIPE.validatePayment();
          });

        } else if (this.tpvEnabled === 'Bee2Pay' && this.state.payFormSelected === 'op') {
          setReservationPayed(reservation, showTaxes);
          this.props.config.showConfirmation(reservation, hotel);

        } else if (this.tpvEnabled === 'DOKU') {

          let payFormCode = inputList['payForm'] && inputList['payForm'].value.get('code');

          this.DOKU.getWebcheckoutPage({
            hotel,
            reservation,
            selectedPayform: payFormCode
          });
        }
        else if (this.tpvEnabled === 'Paylands') {
          return this.PAYLANDS.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            showErrorNotification,
            this.state.payFormSelected
          ).then(() => {
            this.PAYLANDS.validatePayment();
          });
        }
        else if (this.tpvEnabled === 'WeArePlanet') {
          return this.WEAREPLANET.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            showErrorNotification,
            this.state.payFormSelected,
            this.selectedCountry.get('phone_prefix')
          ).then(() => {
            this.WEAREPLANET.validatePayment();
          });
        }
      }
    }).catch(responseError => {
      if(["booking_repeated", "block_points", "invalid_form", "loyalty_register_error"].includes(responseError.message)
       || ["NOT_ENOUGH_POINTS", "TMS_REQUEST_ERROR", "TMS_GENERIC_ERROR"].includes(responseError.error)) {
        return Promise.reject(responseError);
      }

      console.log(responseError);
      if((this.tpvEnabled === 'EPG' || (this.EPG && (this.tpvApplePay || this.tpvBizumEpg)))
        && (responseError.message === "Apple Pay is not set up on your device or the browser is not supported."
          || responseError.message === 'ApplePay cancelled or not response by user')) {
        return showErrorNotification(responseError.message);
      } else if (this.tpvEnabled === 'EPG' && this.EPG.onSubmitPromiseReject) {
        return this.EPG.onSubmitPromiseReject(responseError);
      }
      return responseError;
    });
  };

  receiveMessagePCI = (validForm, inputList, resolve, reject, stateRetriever, toggleModal) => e => {
    const { manageLoading } = stateRetriever();
    const { changePayForm, setReservationToken, reservation, confirmBookingTPV, hotel, showErrorNotification } = this.props.config;
    const message = e.data;
    if (e.origin === PCI_URL && message.indexOf('submit_booking_form') !== -1) {
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      [, this.paymentToken] = message.split(':');
      if (this.paymentToken.length > 0) {
        this.onSubmit(validForm, inputList, resolve, reject);
        if (this.state.showCardValidationError) {
          this.setState(state =>
            mergeDeepRight(state, {
              showCardValidationError: false
            })
          );
        }
      }
    } else if (e.origin === PCI_URL && message.indexOf('error_booking_form') !== -1) {
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      this.setState(state =>
        mergeDeepRight(state, {
          showCardValidationError: true
        })
      );
      // scroll to first unvalid
      if (validForm) {
        this.pciFrame.scrollIntoView();
        window.scrollBy(0, -65);
      }
      reject(Error(message));
    } else if (e.origin === PCI_URL && message.indexOf('card_type_selected') !== -1) {
      const aux = message.split(':');
      window.payForm = this.state.payFormSelected;
      window.cardSelected = aux[1];
    } else if (e.origin === PCI_URL && message.indexOf('redirect_3ds') !== -1) {
      const [, paymentToken, url3DSecureRedirection] = message.split('#');
      this.paymentToken = paymentToken;
        if(this.state.payFormSelected === 'op') {
          confirmBookingTPV(
            inputList,
            false,
            hotel.get('id'),
            reservation.get('tracking_id'),
            hotel.getIn(['tpv', 'id']),
            hotel.getIn(['tpv', 'name']),
            this.paymentToken,
            1
          ).then(()=> {
            window.location.replace(url3DSecureRedirection);
          }).catch((e) => {
            reject();
            showErrorNotification('_%error al procesar su reserva, por favor, vuelva a intentarlo%_');
          });
        } else {
          changePayForm(validForm, inputList, false, false, this.paymentToken).then(() => {
            window.location.replace(url3DSecureRedirection);
          });
        }
    } else if (e.origin === PCI_URL && message.indexOf('B2P') !== -1) {
      const [, paymentToken, url3DSecureRedirection] = message.split('#');
      this.paymentToken = paymentToken;

      confirmBookingTPV(
        inputList,
        false,
        hotel.get('id'),
        reservation.get('tracking_id'),
        hotel.getIn(['tpv', 'id']),
        hotel.getIn(['tpv', 'name']),
        this.paymentToken,
        1
      ).then(()=> {
        window.location.replace(url3DSecureRedirection);
      }).catch((e) => {
        reject();
        showErrorNotification('_%error al procesar su reserva, por favor, vuelva a intentarlo%_');
      });
    } else if (e.origin === PCI_URL && message.indexOf('FORM') !== -1) {
      const [, paymentToken, form] = message.split('#');
      this.paymentToken = paymentToken;
      let decodedForm = atob(form);
      let queryObj = {};
      let redsysApi;
      if (decodedForm.indexOf('new') !== -1) {
        const [, creq, url] = decodedForm.split('#');
        queryObj.creq = creq;
        redsysApi = apiGetter(url, 'form');
      } else {
        const [, PaReq, TermUrl, MD, url] = decodedForm.split('#');
        queryObj.PaReq = PaReq;
        queryObj.TermUrl = TermUrl;
        queryObj.MD = MD;
        redsysApi = apiGetter(url, 'form');
      }
      setReservationToken(reservation, this.paymentToken);
      redsysApi.post(queryObj);
    } else if (e.origin === PCI_URL && message.indexOf('XPAY') !== -1) {
      const [, paymentToken, form] = message.split('#');
      this.paymentToken = paymentToken;
      let decodedForm = atob(form);
      let xpayApi;
      const [url, params] = decodedForm.split('#');
      const jsonParams = JSON.parse(params);
      xpayApi = apiGetter(url,'form');
      setReservationToken(reservation, this.paymentToken);
      xpayApi.post(jsonParams);
    } else if (e.origin === PCI_URL && message.indexOf('SIBS') !== -1) {
      // Sibs 3DS iframe
      const [, paymentToken, form] = message.split('#');
      this.paymentToken = paymentToken;
      let decodedForm = atob(form);
      const [, creq, url] = decodedForm.split('#');

      manageLoading(false);
      if(this.state.payFormSelected === 'op') {
        confirmBookingTPV(
          inputList,
          false,
          hotel.get('id'),
          reservation.get('tracking_id'),
          hotel.getIn(['tpv', 'id']),
          hotel.getIn(['tpv', 'name']),
          this.paymentToken,
          1
        ).then(() => {
          this.showSibsIframe(url, creq, reject);
          setReservationToken(reservation, this.paymentToken);
        }).catch((e) => {
          reject();
          showErrorNotification('_%error al procesar su reserva, por favor, vuelva a intentarlo%_');
        });
      } else {
        this.showSibsIframe(url, creq, reject);
        setReservationToken(reservation, this.paymentToken);
      }
    } else if (["sibs.pt", "sibspayments"].some(domain => e.origin.includes(domain))
      && message.type === "close"
      && message.source === "sibs") {
        if (this.SIBS.eventMessageHandle) return;
        this.SIBS.eventMessageHandle = true;
        // Sibs 3DS result
        reject();
        const {toggleModal } = this.props.config;
        toggleModal(false, "sibsIframe");

        const { manageLoading } = this.stateRetriever();
        this.SIBS.confirm(reservation, manageLoading, this.setCardValidationError, confirmBookingTPV, hotel, inputList);
    } else if (e.origin === PCI_URL && message.indexOf('ADYEN') !== -1) {
      const [, paymentToken, form] = message.split('#');
      this.paymentToken = paymentToken;
      let decodedForm = atob(form);
      let adyenApi;
      const [url, params] = decodedForm.split('#');
      const jsonParams = JSON.parse(params);
      adyenApi = apiGetter(url,'form');
      setReservationToken(reservation, this.paymentToken);
      adyenApi.post(jsonParams);
    }

    return true;
  };

  setCardValidationError = (value) => {
    this.setState(state =>
      mergeDeepRight(state, {
        showCardValidationError: value
      })
    );
  };

  showSibsIframe = (url, creq, reject) => {
    const {toggleModal } = this.props.config;

    toggleModal(true, "sibsIframe", <SibsFrame src={url} creq={creq} closeModal={()=> {
      reject();
      toggleModal(false, "sibsIframe");
    }} />);
  };

  onSubmit = (validForm, inputList, resolve, reject, fromTPV = false) => {
    const { triggerEvent } = this.props.config;

    if (validForm) {
      const { hotel, reservation, confirmBookingTPV, confirmBooking, showTaxes } = this.props.config;
      let promise, errorType;
      let reservationPayformCode = reservation.getIn(['payment','payform_code'], false);
      let amountPayed = false;
      let isBizumReservation = false;
      if(reservationPayformCode === 'op') {
        isBizumReservation = reservation.getIn(['payment', 'bizum_charge'], false) === true;
        amountPayed = reservation.get(showTaxes ? 'total_price_tax' : 'total_price')
      }

      if (fromTPV && (this.tpvEnabled === 'EPG' || (isBizumReservation && this.tpvBizumEpg)) ) {
        errorType = 'payment';
        promise = confirmBookingTPV(
          inputList,
          false,
          hotel.get('id'),
          reservation.get('tracking_id'),
          hotel.getIn(['tpv', 'id']),
          hotel.getIn(['tpv', 'name']),
          this.EPG.paymentToken,
          this.EPG.nRetry
        );
      } else if (fromTPV && ['Redsys', 'xPay', 'Paycomet', 'Stripe','Adyen','DOKU', 'Webpay'].includes(this.tpvEnabled)) {
        errorType = 'payment';
        promise = confirmBookingTPV(
          inputList,
          false,
          hotel.get('id'),
          reservation.get('tracking_id'),
          hotel.getIn(['tpv', 'id']),
          hotel.getIn(['tpv', 'name'])
        );
      } else if(!this.tpvEnabled) {
        errorType = 'pci';
        promise = confirmBooking(inputList, this.paymentToken, amountPayed);
      } else {
        errorType = 'unknown';
        promise = confirmBooking(inputList, this.paymentToken);
      }

      return promise
        .tapCatch(() => triggerEvent('confirm_error', errorType))
        .then(resolve)
        .catch(reject);
    } else {
      triggerEvent('confirm_error', 'required_fields');
      return reject(Error('Invalid form'));
    }
  };

  checkFormEmailEvent = (inputList) => {
    if (!inputList['email'].validation.valid || !inputList['repeatEmail'].validation.valid) return;

    const email = inputList['email'].value;
    if (email === this.lastFormEmailTriggered) return;

    this.lastFormEmailTriggered = email;
    this.props.config.triggerFormEmailEvent(email);
  };

  onChange = (validForm, inputList, model, stateRetriever) => {
    if (model === 'email' || model === 'repeatEmail') {
      this.checkFormEmailEvent(inputList);
    }
  };

  onBlur = (validForm, inputList, model, stateRetriever) => {

    if (model === 'nationality') {
      this.setState(()=> {
        return { showIdentifierDocument : DOCUMENT_TYPES[inputList['nationality'].value?.get("alpha2")] };
      });
    }

    if (model === 'invoice_country') {
      this.setState({ invoiceCountryAlpha2: inputList['invoice_country']?.value?.get('alpha2') || false });
    }

    if (model === 'already_member') return;

    if (model === 'email' || model === 'repeatEmail') {
      this.checkFormEmailEvent(inputList);
    }

    const { reservation, hotel, showErrorNotification,setPayformOP, blacklistedEmails } = this.props.config;
    if (model.indexOf('room_preference') !== -1) {
      this.changeRoomPreferences(validForm, inputList);
    } else if (model === 'payForm') {
      this.onChangePayForm(validForm, inputList, model, stateRetriever);
    } else {
      if (model === 'country') {
        this.selectedCountry = inputList['country'].value;
        if (inputList['phone']?.value) {
          stateRetriever().onGlobalChange('phone', null, true);
        }
        let payFormCode = inputList['payForm'] && inputList['payForm'].value.get('code');
        if (this.tpvEnabled === 'EPG') {
          this.EPG.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            showErrorNotification,
            this.setStateEPGPrepaymentToken,
            this.checkTpvContainer,
            payFormCode
          );
        }
      }
      if (model === 'phone_prefix') {
        this.selectedPhone = '';  // reset del teléfono si cambia el prefijo
      }

      if(model === 'travelclub_card') {
        this.validateTravelclubCard(validForm, inputList, reservation);
      }
      if(model === 'card_holder' ) {
        this.validateCardHolder(validForm, inputList, reservation);
      }

      if(this.tpvEnabled && model === 'email' && blacklistedEmails && blacklistedEmails.includes(inputList['email'].value)) {
        this.changePayformOP();
        setPayformOP(inputList);
        this.onChangePayForm(validForm, inputList, model, stateRetriever, true);
      }

      this.props.config.saveCustomerData(validForm, inputList, model, this.state.showBookerGuestForm).then(() => {
        this.validateRepeatBooking(inputList, reservation);
      });
    }
    this.validForm = validForm;
  };

  onChangePayForm = (validForm, inputList, model, stateRetriever, forceOP = false) => {
    this.stateRetriever = stateRetriever;
    const { reservation, hotel, showErrorNotification, changePayForm, cancelBooking, confirmBooking, showConfirmation, setStripeToken, showTaxes } = this.props.config;
    const { disableSubmit, manageLoading } = stateRetriever();
    let reservationPayformCode = reservation.getIn(['payment','payform_code'], false);
    let amountPayed = false;
    if(reservationPayformCode === 'op') {
      amountPayed = reservation.get(showTaxes ? 'total_price_tax' : 'total_price')
    }

    if (this.paymentToken && this.returnFromSuccessCof) {
      const promise = confirmBooking(inputList, this.paymentToken, amountPayed);
      manageLoading(true);
      return promise
        .then(() => {
          //manageLoading(false);
          return showConfirmation(reservation, hotel);
        })
        .catch((e) => {
          manageLoading(false);
          return showErrorNotification('_%error al procesar su reserva, por favor, vuelva a intentarlo%_');
        });
    }


    if (this.tpvEnabled === 'EPG' || this.tpvApplePay || this.tpvBizumEpg) {
      // l'assignem aquí per tenir-lo disponible en posteriors events de reset
      this.EPG.successEvent = this.EPG.onValidate(
        stateRetriever,
        this.validatePaymentForms,
        this.setStateEPGPrepaymentToken,
        reservation.get('tracking_id')
      );
    }
    const onlinePayment = Map({ code: 'op', name: 'pago online' })
    if(forceOP) {
      inputList["payForm"].onChange(onlinePayment, true);
    }

    let payFormCode = inputList['payForm'] && inputList['payForm'].value.get('code');

    if (payFormCode) {
      disableSubmit(1, 0);

      return new Promise((resolve, reject) => {
        if (!!this.tpvEnabled && reservation.getIn(['payment', 'payform_code']) === 'op' && payFormCode === 'htl' && reservation.get('status') === 'confirmed') {
          cancelBooking(inputList).then(() => resolve());
        } else {
          resolve();
        }
      }).then(() => {
        changePayForm(validForm, inputList, this.tpvEnabled, false, this.paymentToken);
        if ((this.tpvEnabled === 'EPG' && (this.EPG.loadingTpvAuth === false || payFormCode === 'op')  ) || (payFormCode === 'apple' && this.tpvApplePay) || (payFormCode === 'bizum' && this.tpvBizumEpg)) {
          this.EPG.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            showErrorNotification,
            this.setStateEPGPrepaymentToken,
            this.checkTpvContainer,
            payFormCode
          );
        }
        if (this.tpvEnabled === 'Redsys') {
          this.REDSYS.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            showErrorNotification,
            payFormCode
          );
        }
        if (this.tpvEnabled === 'xPay') {
          this.XPAY.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            this.props.config.currentCurrencyCode,
            showErrorNotification
          );
        }
        /*if (this.tpvEnabled === 'Webpay') {
          this.WEBPAY.initialize(
            hotel,
            reservation,
            this.props.config.currentCurrencyCode,
            showErrorNotification
          );
        }*/
        /*if (this.tpvEnabled === 'Cardnet') {
          if(payFormCode === 'op') {
            this.CARDNET.initialize(
              hotel,
              reservation,
              this.props.config.currentCurrencyCode,
              showErrorNotification
            );
          }
        }*/
        if (this.tpvEnabled === 'Adyen') {
          this.ADYEN.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            this.props.config.currentCurrencyCode,
            showErrorNotification
          );
        }
        if (this.tpvEnabled === 'Stripe') {
          if(payFormCode === 'op') {
            this.STRIPE.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              this.props.config.langCode.toLowerCase(),
              this.formID,
              this.props.config.currentCurrencyCode,
              showErrorNotification,
              payFormCode
            );
          } else if(payFormCode === 'htl') {
            const reservation = this.props.config.reservation;
            const hotel = this.props.config.hotel;
            const requiredPrepayment = this.props.config.requiredPrepayment;
            const fullFreeReservation = this.props.config.fullFreeReservation;
            const notRefundable = this.props.config.notRefundable;

            let requiredPrepaymentCalc = 0;
            if (requiredPrepayment > 0 && !fullFreeReservation && !notRefundable ) {
              requiredPrepaymentCalc = requiredPrepayment;

            } else {
              requiredPrepaymentCalc = 0;
            }

            setStripeToken(
              this.props.config.currentCurrencyCode,
              this.props.config.langCode.toLowerCase(),
              requiredPrepaymentCalc,
              hotel.get('code'),
              reservation.get('tracking_id'),
              document.URL,
              true,
              payFormCode
            );

          }else if(payFormCode === 'googlePay') {

            const reservation = this.props.config.reservation;
            const hotel = this.props.config.hotel;

            const amountPromoPaid = reservation.getIn(['payment', 'amount_promo_paid'], 0);
            let amountToPay = reservation.get('total_price_tax') - amountPromoPaid;

            setStripeToken(
              this.props.config.currentCurrencyCode,
              this.props.config.langCode.toLowerCase(),
              amountToPay,
              hotel.get('code'),
              reservation.get('tracking_id'),
              document.URL,
              true,
              payFormCode
            );
          }
        }

        this.resolvePaymentEvent(payFormCode);

        this.setState(state =>
          mergeDeepRight(state, {
            payFormSelected: payFormCode
          })
        );
        disableSubmit(0, 0);
      }).catch(error => {
        disableSubmit(0, 0);
      });
    }
  };

  setAmazonReferenceId = (validForm, inputList) => (amazonOrderRefId, nRetry) => {
    const { changePayForm } = this.props.config;
    changePayForm(validForm, inputList, 'amazon_pay', { amazonOrderRefId: amazonOrderRefId, TPVnRetry: nRetry });
    return amazonOrderRefId;
  };

  setPayPalOrderId = (validForm, inputList) => (OrderId, nRetry) => {
    const { changePayForm } = this.props.config;
    changePayForm(validForm, inputList, 'paypal', { PayPalOrderId: OrderId, TPVnRetry: nRetry });
    return OrderId;
  };

  setInnerRef = (ref) => this.setState({ heightRef: ref });

  changePayformOP = () => {
    this.setState({selecectedPayform: 'op'});

  }

  toggleRoomPreferences = idx => e => {
    e.preventDefault();
    this.setState(state =>
      mergeDeepRight(state, {
        showRoomPreferences: {
          [idx]: !state.showRoomPreferences[idx]
        }
      })
    );
  };

  toggleEditUserFields = e => {
    e.preventDefault();
      this.setState(state =>
        mergeDeepRight(state, {
          showEditUserFields: !state.showEditUserFields,
          showUserInfo : !state.showUserInfo,
          userChanged : true
        })
      );
  };

  updateAfterTransition = () => {
    if (this.state.editCommentary) {
      this.setState({ heightContainer: 'auto' });
    }
  };

  toggleAdditionalCommentary = e => {
    e.preventDefault();
    this.setState(state => ({
      editCommentary: !state.editCommentary,
      heightContainer: this.state.heightRef.scrollHeight
    }));
  };

  togglePromotionalCode = e => {
    e.preventDefault();
    this.setState(state => ({
      showPromotionalBox: !state.showPromotionalBox
    }));
  };


  toggleTravelClub = e => {
    e.preventDefault();
    this.setState(state => ({
      showTravelClub: !state.showTravelClub
    }));
  };

  changeRoomPreferences = (validForm, inputList) => {
    const blockIdx = keys(inputList)[0].split('-')[1];
    return this.props.config.changeRoomPreferences(blockIdx, inputList);
  };

  setPciFrameRef = ref => {
    this.pciFrame = ref;
  };

  AcceptAlertBookingRepeated = isAccepted => e => {
    e.preventDefault();
    this.setState(
      state => {
        return {
          repeatedBooking: {
            ...state.repeatedBooking,
            clientAccepted: isAccepted
          }
        };
      },
      () => {
        if (isAccepted) {
          this.acceptedReapetedBookingPromise.resolve();
        } else {
          this.acceptedReapetedBookingPromise.reject(Error('booking_repeated'));
        }
      }
    );
  };

  paymentCallbackRegister = callback => {
    this.paymentCallback = callback;
  };

  toggleBookerGuest = e => {
    this.setState(state => ({
      showBookerGuestForm: !state.showBookerGuestForm
    }));
  };

  toggleInvoiceData = e => {
    this.setState(state => ({
      showInvoiceData: !state.showInvoiceData
    }));
  };

  selectCountryFilter = (option, inputValue) => {
    if(!option || !option.data || !option.data.get) return false;

    if (!isNaN(inputValue.charAt(0)) || inputValue.startsWith('+')) {
      if(inputValue.startsWith('+')) inputValue = inputValue.substring(1);
      const phonePrefix = option.data.get('phone_prefix') || '';
      return phonePrefix.startsWith(inputValue);
    }

    const name = option.data.get('name') || '';
    return name.toLowerCase().startsWith(inputValue.toLowerCase());
  };

  updateMenuWidth = (ref, stateKey) => {
    const el = ref.current;
    if (!el) return;
    const width = el.offsetWidth;
    if (width !== this.state[stateKey]) {
      this.setState({ [stateKey]: width });
    }
  };

  updateCountrySelectMenuWidth = () => {
    this.updateMenuWidth(this.phoneContainerRef, 'countrySelectMenuWidth');
  };

  updateDocumentMenuWidth = () => {
    this.updateMenuWidth(this.documentTypeRef, 'docTypeSelectMenuWidth');
  };

  getStripeInstance = (publicKey, stripeAccount) => {

    const currentKey = `${publicKey}-${stripeAccount}`;

    if (this.cachedStripePromise && this.cachedStripeKey === currentKey) {
      return this.cachedStripePromise;
    }

    this.cachedStripeKey = currentKey;
    const stripeCons = { stripeAccount: stripeAccount };
    this.cachedStripePromise = loadStripe(publicKey, stripeCons);

    return this.cachedStripePromise;
  };

  render() {
    const { config, theme, content } = this.props;
    const {
        hotel,
        reservation,
        reservationTotals,
        reservationTotalsBothModes,
        langCode,
        checkin,
        stayLength,
        hotelCurrencyCode,
        currentCurrencyCode,
        countries,
        hotelPreferences,
        blocks,
        sections,
        cfees15d,
        showTaxes,
        reservationPaid,
        fullFreeReservation,
        directPayment,
        amountToPay,
        managementGroupID,
        gift_voucher,
        showErrorNotification,
        langInfo,
        currencies,
        requiredPrepayment,
        requiredPrepaymentValue,
        requiredPrepaymentType,
        stripeToken,
        loyaltyUser,
        loyaltySelected,
        loyaltyType,
        ipCountry,
        giftCodeDiscount,
	paymentPointsDiscount,
        blacklistedEmails,
        acceptPayLinks,
        hotelConfig,
        stepCode,
        summaryPriceBreakdown
    } = config;
    const { classes } = theme.styles;

    const isStarTraveler = STAR_TRAVELER_CODE === loyaltyType;

    const showUserInfo = this.state.showUserInfo;
    const showEditUserFields = this.state.showEditUserFields;

    const resDocDefault = reservation.getIn(['customer', 'document_type']);
    const defaultDoc = this.state.showIdentifierDocument && (find((curr)=>{
      return curr.value === resDocDefault;
    }, this.state.showIdentifierDocument) || this.state.showIdentifierDocument[0]);
    /* for show taxes in mobile */
    const summaryBreakdownMode = hotelConfig.get('summary_taxes_breakdown', 'default');
    const taxes = parseTaxes(hotel, reservation, summaryBreakdownMode);
    // flexmyroom | secure cancellation
    const rateSecureCancellation = reservation && reservation?.get('rates')?.some(d => d?.get('secure_cancellation', false));
    const discountSecureCancellation = reservation && reservation?.get('discounts')?.some(d => d?.get('secure_cancellation', false));
    const serviceSecureCancellation = reservation && reservation?.get('services')?.some(d => d?.get('secure_cancellation', false));
    const pmsName = hotel && hotel.get('pms');
    const pms = ((rateSecureCancellation || discountSecureCancellation || serviceSecureCancellation) && pmsName === 'FlexMyRoom') ? 'FlexMyRoom' : false;
    let reservationEmail = reservation.getIn(['customer', 'email'], '')
    let blacklistedEmail = this.tpvEnabled && reservationEmail && blacklistedEmails && blacklistedEmails.includes( reservationEmail );

    const hotelId = hotel && hotel.get('id');
    const penalties = getPenalties(reservation, managementGroupID === PROPERTY_MANAGEMENT_GROUP, pms, langCode, managementGroupID, getPenaltyTimezone(hotel), getPenaltyChargebackUSA(hotel));
    const notRefundable = penalties[0].nr || penalties[0].flexible || false;
    const hotelCode = hotel && hotel.get('code');
    const showCVC = hotel && hotel.getIn(['payment_info', 'show_cvc']) ? 1 : 0;
    const trackingId = reservation && reservation.get('tracking_id');
    const checkinPCI = checkin && moment(checkin).format('DDMMYYYY');
    const checkoutPCI =
      checkin &&
      moment(checkin)
        .add(stayLength, 'days')
        .format('DDMMYYYY');

    const taxesNonIncludedAmount = round(
      taxes?.nonIncluded.reduce((sum, tax) => sum + tax.tax_amount, 0)
    );

    // GLOSARIO.md FCL-003 - la fee obligatoria no debe listarse como un impuesto mas en el desglose mobile;
    // usa el mismo split que AvailMainSideSummary/AvailMainSideSummaryTMS (protege los taxes de tarifa/servicio)
    const { taxes: mobileSplitTaxes } = applyMandatoryFeeSplit(taxes, summaryPriceBreakdown);
    const mobileNonIncludedTaxes = mobileSplitTaxes.nonIncluded;

    const totalPrice = reservationTotals ? reservationTotals.get('total_price') : 0;
    const totalPriceWithTaxes = reservationTotalsBothModes ? reservationTotalsBothModes.getIn(['with_taxes','total_price']) : 0;
    const totalPriceWithoutTaxes = reservationTotalsBothModes.getIn(['without_taxes','total_price']);
    const discountAmount = reservationTotals ? reservationTotals.get('discount_amount') : 0;
    const discountPercent = reservationTotals ? reservationTotals.get('discount_percent') : 0;
    const redsysRedirection = (this.tpvEnabled === 'Redsys' && this.tpvEnabledType === 'redireccion');
    const redsysBizum = (this.tpvEnabled === 'Redsys' && this.tpvBizumRedsys === '1');
    const epgBizum = this.tpvBizumEpg === '1';
    const applePayRedsys = this.tpvApplePayRedsys === 'true';
    const applePay = this.tpvApplePay || applePayRedsys;
    let altCurrency =  (this.altCurrency && this.altCurrency !== '') ? this.altCurrency :false ;
    if(altCurrency) {
      let existsCurrency = currencies.find(c => c.get('code') === altCurrency) || false;
      if(!existsCurrency || currentCurrencyCode === altCurrency) {
        altCurrency = false;
      }
    }
    const paycometRedirection = this.tpvEnabled === 'Paycomet';
    const xpayRedirection = this.tpvEnabled === 'xPay' && reservation.getIn(['payment', 'payform_code'], false) === 'op';
    const cardnetRedirection = this.tpvEnabled === 'Cardnet' && reservation.getIn(['payment', 'payform_code'], false) === 'op';
    const webpayRedirection = this.tpvEnabled === 'Webpay' && reservation.getIn(['payment', 'payform_code'], false) === 'op';
    const adyenRedirection = this.tpvEnabled === 'Adyen' && reservation.getIn(['payment', 'payform_code'], false) === 'op';
    const stripeRedirection = this.tpvEnabled === 'Stripe' && reservation.getIn(['payment', 'payform_code'], false) === 'op';
    const isBizum = (redsysBizum || epgBizum) && reservation && reservation.getIn(['payment', 'payform_code'], false) === 'op' && reservation.getIn(['payment', 'bizum_charge'], false) === true;
    const isApplePay = applePay && reservation && reservation.getIn(['payment', 'payform_code'], false) === 'op' && reservation.getIn(['payment', 'apple_charge'], false) === true;
    const isGooglePay = reservation && reservation.getIn(['payment', 'payform_code'], false) === 'op' && reservation.getIn(['payment', 'googlePay_charge'], false) === true;
    const alternativePayform = (isBizum && 'bizum')
      || (isApplePay && 'apple')
      || (isGooglePay && 'googlePay')
      || false;
    const isNemuru = this.nemuruEnabled && reservation && reservation.getIn(['payment', 'payform_code'], false) === 'bnpl'  && reservation.getIn(['payment', 'tpv_code'], false) === 'nemuru';
  
    const applePayRedsysSelectable = applePayRedsys && !blacklistedEmail && isAppleDevice();
    const otherOps = this.payPalEnabled || this.amazonPayEnabled || redsysBizum || epgBizum || applePayRedsysSelectable;
    const isStripeHtl = this.tpvEnabled === 'Stripe' && this.state.payFormSelected === 'htl';
    const isStripeGooglePay = this.tpvEnabled === 'Stripe' && this.state.payFormSelected === 'googlePay';
    const opShow = (redsysRedirection || paycometRedirection || stripeRedirection || xpayRedirection || cardnetRedirection || adyenRedirection || webpayRedirection) && !otherOps && (notRefundable || blacklistedEmail);
    let showTpvForm = !reservationPaid && !opShow;
    let reservationPayformCode = reservation.getIn(['payment','payform_code'], false);
    const UserLoggedST = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;

    const endTotalPrice =
      summaryPriceBreakdown && taxesNonIncludedAmount > 0
        ? (showTaxes ? totalPriceWithTaxes : totalPriceWithoutTaxes) + taxesNonIncludedAmount
        : summaryPriceBreakdown
          ? totalPriceWithTaxes
          : totalPrice + giftCodeDiscount + paymentPointsDiscount;

    // Forces online payment (op) and hides pay-at-hotel option (htl) if PMS is flexmyroom and TPV is enabled
    if (pms && this.tpvEnabled) {
      showTpvForm = false;
      reservationPayformCode = 'op';
    }

    const cityTax = hotel && hotel.get('city_tax');
    const cityTaxValue = hotel && hotel.get('city_tax_value');
    const isMobile = this.props.theme.deviceType !== 'DESK';
    const hasPromotion = reservation && reservation.getIn(['promotion', 'code'], false);
    const hidePromotionCode = hotel && !hasPromotion && managementGroupID !== PROPERTY_MANAGEMENT_GROUP && isMobile && hotel.get('has_mobile_discount', false) === true;
    const legalText = this.props.content.getHasKeyAndContent('_%el uso de este formulario implica el tratamiento de tus datos%_');
    const dataControllerText = this.props.content.getHasKeyAndContent('_%data_controller_text%_');
    let stripeOptions = false;
    let stripePromise = false;
    const hideArrivalTimeBox = hotelConfig && hotelConfig.get('hide_arrival_time_box', false);
    const showCustomerTreatment = hotelConfig && hotelConfig.get('show_customer_treatment', false);
    const showInvoiceForm = hotelConfig && hotelConfig.get('show_invoice_form', false);

    const identityDocumentMode = hotelConfig && hotelConfig.get('identity_document', 'disabled');
    const showIdentityDocument = identityDocumentMode !== 'disabled';
    const isIdentityDocumentRequired = identityDocumentMode === 'required';

    if(this.tpvEnabled === 'Stripe'){

      let tpv = hotel.getIn(['tpv', 'tpv_params'], false);
      let publicKey = tpv && tpv.find(p => p.get('code') === 'public_key', Map()).get('value', '');
      let stripeAccount = tpv && tpv.find(p => p.get('code') === 'account', Map()).get('value', '');

      stripePromise = this.getStripeInstance(publicKey, stripeAccount);

      if(isStripeHtl && stripeToken)
      {
        stripeOptions = {
          clientSecret: stripeToken,
          locale: langCode,
          appearance : {
            theme: 'flat',
          }
        };
      }else if(isStripeGooglePay){

        stripeOptions = {
          clientSecret: stripeToken,
        };
      }

    }
    let showAlertRepeatedBooking =
      this.state.repeatedBooking.status === 'repeated' &&
      this.state.repeatedBooking.submited &&
      this.state.repeatedBooking.clientAccepted === null;

    const PSD2Active = hotel && hotel.getIn(['pci', 'psd2_active'], false) === true && !!hotel.getIn(['tpv', 'name'], false);
    const hotelCountry = hotel && hotel.get('country_iso_code', '');
    const hotelUS = (hotelCountry === 'US' ||  hotelCountry === 'MX' ||  hotelCountry === 'CA') && managementGroupID === PROPERTY_MANAGEMENT_GROUP;

    let requiredPrepaymentText = '';
    let requiredPrepaymentCalc = 0;

    if (requiredPrepayment > 0 && !fullFreeReservation && !notRefundable && currencies) {
      requiredPrepaymentCalc = requiredPrepayment;
      requiredPrepaymentText = getPrepaymentText(
        requiredPrepayment,
        requiredPrepaymentValue,
        requiredPrepaymentType,
        currencies,
        currentCurrencyCode,
        hotelCurrencyCode,
        langInfo,
        content
      );
    } else if (this.tpvEnabled === 'SIBS') {
      requiredPrepaymentCalc = reservation.get('total_price_tax') - reservation.getIn(['payment', 'amount_promo_paid'], 0);
    } else if(/*UserLoggedST && */reservationPayformCode === 'op') {
      if(hotelUS) {
        requiredPrepaymentCalc = reservation.get('total_price_tax') - reservation.getIn(['payment', 'amount_promo_paid'], 0) - reservation.getIn(["loyalty", "total_points_price"], 0);
      } else {
        requiredPrepaymentCalc = amountToPay;
      }
    } else {
      requiredPrepaymentCalc = 0;
    }

    const country = (reservation && reservation.getIn(['customer', 'country'], false));
    const showStateSelector = country === 'AR';
    const states = fromJS(AR_STATES);

    const currentState = (reservation && reservation.getIn(['customer', 'state'], false));

    const enableRegisterUserST = isStarTraveler && loyaltySelected && !loyaltyUser;


    //ShowTravelClub
    const ipTravelClub = ['ES', 'PT', 'AD'].includes(ipCountry);
    const { countrySelectMenuWidth } = this.state;
    const { docTypeSelectMenuWidth } = this.state;
    const cx = this.props.theme.bind();
    const stylesforSelect = reactSelectStyles({docTypeSelectMenuWidth: docTypeSelectMenuWidth})

    // Datos de factura (invoice_data)
    const invoiceData = reservation.getIn(['customer', 'invoice_data'], Map());
    const invoiceIsSpain = this.state.invoiceCountryAlpha2 === 'ES';
    const invoiceDefaultDocType = INVOICE_DOCUMENT_TYPES.find(opt => opt.value === invoiceData.get('document_type', false));
    const invoiceDefaultCountry = countries.find(country => country.get('alpha2') === invoiceData.get('country', false));
    const invoiceTaxValidation = {
      type: 'tax_number',
      countryModel: 'invoice_country',
      documentModel: 'invoice_document_type',
      taxModel: 'invoice_tax_number',
      countries: ['ES']
    };
    const payformsWithOwnButton = ['amazon_pay','paypal', 'googlePay'];

    return (
      <div className={classes.defaultStyle}>
        <LoyaltyUserPoints/>
        {showAlertRepeatedBooking && (
          <div className={classes.alertContainer}>
            <div id="login-front"></div>
            <div className={classes.alertContent}>
              <RichText
                innerStyle={['alertForm', 'bold', classes.alertTitle]}
                translate={true}
                ucFirst={true}
                text={'_%¡Atención!%_'}
              />
              <RichText
                innerStyle={['alertForm']}
                translate={true}
                ucFirst={true}
                text={'_%ya has realizado una reserva similar.¿Seguro que deseas confirmar tu reserva?%_'}
              />
              <div className={classes.alertButtonContainer}>
                <Button
                  onClick={this.AcceptAlertBookingRepeated(true)}
                  richText={{
                    translate: true,
                    text: '_%si%_',
                    ucFirst: true
                  }}
                  innerStyle={['alertButton']}
                />
                <Button
                  onClick={this.AcceptAlertBookingRepeated(false)}
                  richText={{
                    translate: true,
                    text: '_%no%_',
                    ucFirst: true
                  }}
                  innerStyle={['alertButton']}
                />
              </div>
            </div>
          </div>
        )}


        <div className={classes.page}>
          <div className={classes.section}>
          {<LoyaltyLogin customerForm={true} />}
            <div className={classes.sectionForm}>
              {showEditUserFields && <RichText innerStyle={[classes.title]} ucFirst={true} text={"_%tus Datos%_"} translate={true} />}
              <Form
                formVersion={2}
                onValidateForm={(validForm, inputList)=>{
                  if (!validForm && !showEditUserFields) {
                    const hiddenFieldsError = this.validateFields(pick(['name', 'surname', 'email', 'repeatEmail', 'phone', 'country', 'identity_document'], inputList));
                    !hiddenFieldsError && this.setState({ showUserInfo: false, showEditUserFields:true });
                  }
                }}
                filterInputModel={(inputList) => {
                  let newInputs = inputList;
                  const showIdentifierDocument = DOCUMENT_TYPES[inputList['nationality']?.value?.get('alpha2')];

                  if(enableRegisterUserST && showIdentifierDocument) {
                    newInputs = omit(['booker_check','booker_repeat_email'], newInputs);
                  } else if(enableRegisterUserST) {
                    newInputs = omit(['document_type', 'tax_number','booker_check','booker_repeat_email'], newInputs);
                  } else {
                    newInputs = omit(['nationality', 'document_type', 'tax_number','booker_check','booker_repeat_email'], newInputs);
                  }

                  return newInputs;
                }}
                disableLoading={true}
                loadingTemplate={LoadingConfirmation}
                id={this.formID}
                onChange={this.onChange}
                onBlur={this.onBlur}
                onSubmit={this.onSubmitButton}
                onMount={this.onChangePayForm}
                innerStyle={classes.customerForm}>
                <LoyaltyUserInfo
                  visible={showUserInfo}
                  toggle={this.toggleEditUserFields}
                  phone={this.selectedPhone}
                  flag={this.props.content?.getCountryFlags(this.selectedCountry.get('alpha2', ''))}
                  country={this.selectedCountry.get('phone_prefix', '')}
                  classes={classes}
                  />
                <div className={[showEditUserFields ? '' : classes.userTravelContainer]}>
                  {/* field name */}
                  <label className={[ classes.inputBox, cx({hide: !showEditUserFields}),  classes.inputName].join(' ')} ref={'name'}>
                    <div className={classes.nameContainer}>
                      {showCustomerTreatment && (
                        <div className={[classes.selectBox, classes.treatmentSelect].join(' ')}>
                          <div className={classes.arrivingHours}>
                            <div className={classes.labelText}>
                              <RichText innerStyle={classes.hourslabel} text={'_%Tratamiento%_'} translate={true}
                                        ucFirst={true} />
                            </div>
                          </div>
                          <div className={classes.selectBox}>
                            <SelectField
                              getOptionLabel={option => option.label}
                              getOptionValue={option => option.value}
                              model={'customer_treatment'}
                              styles={stylesforSelect}
                              innerStyle={[classes.hoursSelector]}
                              placeholder={""}
                              options={this.customerTreatmentList}
                              isSearchable={false}
                              components={{
                                SingleValue: ArrivingHoursOptions(this.customerTreatmentList, classes)
                              }}
                            />
                          </div>
                        </div>
                      )}
                      <div className={[cx({withTreatment: showCustomerTreatment, inputBox: showCustomerTreatment})].join(' ')}>
                        <InputField
                          model={'name'}
                          defaultValue={reservation.getIn(['customer', 'name'], '') || (loyaltyUser?.getIn(['name'], ''))}
                          innerStyle={['inputText', classes.inputText]}
                          validationsFields={{ field: 'nombre' }}
                          autoFocus={true}
                          validations={[
                            'required',
                            { type: 'maxLength', maxLength: 100 },
                            { type: 'minLength', minLength: 2 }
                          ]}
                        />
                        <InputNotify model={'name'} />
                        <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%nombre%_'} translate={true} />
                      </div>
                    </div>

                  </label>
                  <label className={[classes.inputBox, showEditUserFields ? '' : classes.hide].join(' ')}
                         ref={'surname'}>
                    <InputField
                      model={'surname'}
                      defaultValue={reservation.getIn(['customer', 'surname'], '') || (loyaltyUser?.getIn(['surname'], ''))}
                      validationsFields={{ field: 'apellidos' }}
                      validations={[
                        'required',
                        { type: 'minLength', minLength: 2 },
                        { type: 'maxLength', maxLength: 100 }
                      ]}
                      innerStyle={['inputText', classes.inputText]}
                    />
                    <InputNotify model={'surname'} />
                    <RichText innerStyle={[classes.labelText, 'capitalize']} text={isUsDomain() ? '_%last_name%_' : '_%apellidos%_'} translate={true} />
                  </label>
                  <label className={[classes.inputBox, showEditUserFields ? '' : classes.hide].join(' ')} ref={'email'}>
                    <InputField
                      model={'email'}
                      defaultValue={reservation.getIn(['customer', 'email'], '') || (loyaltyUser?.getIn(['email'], ''))}
                      validationsFields={{ field: 'email' }}
                      validations={[
                        'required',
                        'email',
                        'loyaltyEmail',
                        {
                          type: 'compareField',
                          invalidText: '',
                          alterModel: 'repeatEmail',
                          alterField: 'repetir email'
                        },
                      ]}
                      innerStyle={['inputText', classes.inputText]}
                      type={'email'}
                    />
                    <InputNotify model={'email'} />
                    <div className={classes.labelText}>
                      <div className={managementGroupID === PROPERTY_MANAGEMENT_GROUP && classes.emailWithInfo}>
                          <RichText innerStyle={['capitalize']} text={'_%email%_'} translate={true}/>
                        {managementGroupID === PROPERTY_MANAGEMENT_GROUP &&
                        <TooltipWrapper
                          popover={<span className={[classes.ratePopover]}>
                            <RichText
                              translate={true}
                              text={'_%en caso de la no finalización de la reserva te enviaremos un email, a esta dirección de correo, por si has tenido algún problema en el proceso.%_'}
                              ucFirst={true}
                            /></span>}
                          popoverStyle={classes.rateTooltip}
                          bottomLimit={100}
                          typeTooltip={'infoEmailTooltip'}
                          pointerStyle={[classes.tooltipPointerStyle, classes.tooltipEmail].join(' ')}
                          posX={'middle'}
                          posY={'top'}>
                          <div className={classes.infoFloatIcon}>
                            <Image svg={'infoIcon'}/>
                          </div>
                        </TooltipWrapper>}
                      </div>
                    </div>
                  </label>
                  <label className={[classes.inputBox, showEditUserFields ? '' : classes.hide].join(' ')} ref={'repeatEmail'}>
                    <InputField
                      model={'repeatEmail'}
                      defaultValue={reservation.getIn(['customer', 'email'], '') || (loyaltyUser?.getIn(['email'], ''))}
                      validationsFields={{ field: 'repetir email' }}
                      validations={[
                        'required',
                        'email',
                        {
                          type: 'compareField',
                          alterModel: 'email',
                          alterField: 'email'
                        },
                      ]}
                      innerStyle={['inputText', classes.inputText]}
                      type={'email'}
                    />
                    <InputNotify model={'repeatEmail'} />
                    <RichText
                      innerStyle={[classes.labelText]}
                      ucFirst={true}
                      text={'_%repetir email%_'}
                      translate={true}
                    />
                  </label>
                  {enableRegisterUserST && <>
                    <label className={classes.inputBox}>
                      <div className={classes.arrivingHours}>
                        <div className={[classes.labelText, classes.nationalityLabel].join(' ')}>
                          <RichText
                            ucFirst={true}
                            text={'_%nacionalidad%_'}
                            translate={true}
                          />
                        </div>
                      </div>
                      <div className={[classes.selectBox, classes.nationalityContainer].join(' ')}>
                        <SelectField
                          verifyInListSelected={true}
                          placeholder={""}
                          getOptionLabel={option => option.get('name')}
                          getOptionValue={option => option.get('alpha2')}
                          model={'nationality'}
                          validations={['required', 'tax_number']}
                          innerStyle={[classes.nationalitySelector]}
                          defaultValue={this.defaultNationality}
                          options={countries}
                          styles={stylesforSelect}
                        />
                      </div>
                    </label>
                  </>}
                  {/* field phone */}
                  <label className={[classes.inputBox, showEditUserFields ? '' : classes.hide].join(' ')}>
                    <div className={classes.phoneContainer} ref={this.phoneContainerRef}>
                      <SelectCountry
                        defaultCountry={this.defaultCountry}
                        countries={countries}
                        arrowPosition={langCode}
                        customFilter={this.selectCountryFilter}
                        countrySelectMenuWidth={countrySelectMenuWidth}  
                        model={'phone_prefix'} 
                      />
                      <label className={classes.inputBox} ref={'phone'}>
                        <InputField
                          model={'phone'}
                          defaultValue={reservation.getIn(['customer', 'phone'], '') || this.selectedPhone}
                          validationsFields={{ field: 'teléfono' }}
                          validations={['required', { type: 'phoneLength', prefixModel: 'country' }]}
                          innerStyle={['inputText', classes.inputText]}
                          type={'tel'}
                        />
                        <InputNotify model={'phone'} />
                        <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%teléfono%_'}
                                  translate={true} />
                      </label>
                    </div>
                  </label>
                  {enableRegisterUserST && this.state.showIdentifierDocument && <>
                    <label className={classes.inputBox}>
                      <div className={classes.docTypeContainer} ref={this.documentTypeRef}>
                        <div className={[classes.selectBox, classes.selectDocType].join(' ')}>
                          <SelectField
                            getOptionLabel={option => option.value}
                            getOptionValue={option => {
                              return option.value;
                            }}
                            placeholder={""}
                            model={'document_type'}
                            verifyInListSelected={true}
                            validations={['required', 'tax_number']}
                            innerStyle={[classes.documentSelect]}
                            defaultValue={defaultDoc}
                            options={this.state.showIdentifierDocument}
                            styles={stylesforSelect}
                          />
                        </div>
                        {this.state.showIdentifierDocument && <label className={classes.inputBox} ref={'tax_number'}>
                          <InputField
                            model={'tax_number'}
                            defaultValue={reservation.getIn(['customer', 'tax_number'], '') || (loyaltyUser?.getIn(['tax_number'], ''))}
                            innerStyle={['inputText', classes.inputText]}
                            validationsFields={{ field: 'documento identidad' }}
                            validations={[
                              'required',
                              'tax_number'
                            ]}
                          />
                          <InputNotify model={'tax_number'} />
                          <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%documento identidad%_'}
                                    translate={true} />
                        </label>}
                      </div>
                    </label>
                  </>}
                  {showIdentityDocument && !(enableRegisterUserST && this.state.showIdentifierDocument) && <label className={[classes.inputBox, showEditUserFields ? '' : classes.hide].join(' ')} ref={'identity_document'}>
                    <InputField
                      model={'identity_document'}
                      defaultValue={reservation.getIn(['customer', 'identity_document'], '')}
                      innerStyle={['inputText', classes.inputText]}
                      validationsFields={{ field: 'documento de identidad' }}
                      validations={[
                        ...(isIdentityDocumentRequired ? ['required'] : []),
                        'spanish_id_document'
                      ]}
                    />
                    <InputNotify model={'identity_document'} />
                    <RichText
                      innerStyle={[classes.labelText, 'capitalize']}
                      text={'_%documento de identidad%_'}
                      translate={true}
                    />
                  </label>}
                  {/* addressLine1 */}
                  {(hotelUS || this.tpvEnabled === 'Cardnet' || this.tpvEnabled === 'WeArePlanet' ) &&
                    <label
                      className={[classes.inputBox, managementGroupID, showEditUserFields ? '' : classes.rightMargin].join(' ')}
                      ref={'addressLine1'}>
                      <InputField
                        model={'addressLine1'}
                        innerStyle={['inputText', classes.inputText]}
                        type={'text'}
                        validationsFields={{ field: 'dirección' }}
                        validations={[
                          'required',
                          { type: 'minLength', minLength: 2 },
                          { type: 'maxLength', maxLength: 100 }
                        ]}
                      />
                      <InputNotify model={'addressLine1'} />
                      <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%dirección%_'}
                                translate={true} />
                    </label>}
                  {(hotelUS || this.tpvEnabled === 'Cardnet' )  && <>
                    <label className={[classes.inputBox, showEditUserFields ? '' : classes.rightMarginNo].join(' ')}
                           ref={'customerCountry'}>
                      <RichText
                        innerStyle={[classes.countryLabel, classes.labelText]}
                        ucFirst={true}
                        text={'_%país%_'}
                        translate={true}
                      />
                      <div className={[classes.selectBox, classes.countryContainer].join(' ')}>
                        <SelectField
                          verifyInListSelected={true}
                          getOptionLabel={option => option.get('name')}
                          getOptionValue={option => option.get('alpha2')}
                          model={'customerCountry'}
                          validations={['required']}
                          placeholder={""}
                          innerStyle={[classes.nationalitySelector]}
                          defaultValue={this.defaultNationality}
                          options={countries}
                          styles={stylesforSelect}
                        />
                      </div>
                    </label>
                  </>}
                  {/* city */}
                  {(hotelUS || this.tpvEnabled === 'Cardnet' ) &&
                    <label className={[classes.inputBox, showEditUserFields ? '' : classes.rightMargin].join(' ')}
                           ref={'customerCity'}>
                      <InputField
                        model={'customerCity'}
                        innerStyle={['inputText', classes.inputText]}
                        type={'text'}
                        validationsFields={{ field: 'ciudad' }}
                        validations={[
                          'required',
                          { type: 'minLength', minLength: 2 },
                          { type: 'maxLength', maxLength: 100 }
                        ]}
                      />
                      <InputNotify model={'customerCity'} />
                      <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%ciudad%_'} translate={true} />
                    </label>
                  }
                  {/* postCode */}
                  {(hotelUS || this.tpvEnabled === 'Cardnet' ) &&
                    <label className={[classes.inputBox, showEditUserFields ? '' : classes.rightMarginNo].join(' ')}
                           ref={'postCode'}>
                      <InputField
                        model={'postCode'}
                        innerStyle={['inputText', classes.inputText]}
                        type={'text'}
                        validationsFields={{ field: 'código postal' }}
                        validations={[
                          'required',
                          { type: 'minLength', minLength: 2 },
                          { type: 'maxLength', maxLength: 100 }
                        ]}
                      />
                      <InputNotify model={'postCode'} />
                      <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%código postal%_'}
                                translate={true} />
                    </label>
                  }
                  {showStateSelector &&
                    <label className={[classes.inputBox].join(' ')}>
                      <div className={classes.cityContainer}>
                        <RichText
                          innerStyle={[classes.citiesLabel, classes.labelText]}
                          ucFirst={true}
                          text={'_%ciudad%_'}
                          translate={true}
                        />
                        <div className={[classes.selectBox].join(' ')}>
                          <SelectField
                            getOptionLabel={option => option.get('name')}
                            getOptionValue={option => option.get('code')}
                            model={'state'}
                            placeholder={""}
                            innerStyle={[classes.citySelector]}
                            defaultValue={states.find(s => s.get('code') === currentState) || states.first()}
                            options={states}
                            styles={stylesforSelect}
                          />
                        </div>
                      </div>
                    </label>
                  }
                  {!hideArrivalTimeBox &&
                  <label className={[classes.inputBox, showEditUserFields ? '' : classes.rightMargin].join(' ')}>
                    <div className={[classes.labelText, classes.labelHours].join(' ')}>
                        <RichText innerStyle={classes.hourslabel} text={'_%hora de llegada%_'} translate={true}
                                  ucFirst={true} />
                      <TooltipWrapper
                        popover={
                          <span className={[classes.ratePopover].join(' ')}>
                            <RichText text={'_%hora de la zona horaria del hotel%_'} translate={true} ucFirst={true} />
                            <br />
                            <RichText
                              text={
                                '_%no podemos garantizar que la habitación esté disponible cuando llegues, pero haremos lo posible por satisfacer la petición.%_'
                              }
                              translate={true}
                              ucFirst={true}
                            />
                          </span>
                        }
                        typeTooltip={'arrivingHoursToolTip'}
                        popoverStyle={classes.rateTooltip}
                        bottomLimit={100}
                        pointerStyle={[classes.tooltipPointerStyle, classes.tooltipArrinvingHour].join(' ')}
                        posX={'middle'}
                        posY={'top'}>
                        <div className={classes.infoFloatIcon}>
                          <Image svg={'infoIcon'} />
                        </div>
                      </TooltipWrapper>
                    </div>
                    <div className={classes.selectBox}>
                      <SelectField
                        getOptionLabel={option => option.label}
                        getOptionValue={option => option.value}
                        model={'hours_arrival'}
                        styles={stylesforSelect}
                        innerStyle={[classes.hoursSelector]}
                        placeholder={""}
                        defaultValue={this.defaultArrivalHour}
                        options={this.arrivingHoursList}
                        isSearchable={false}
                        components={{
                          SingleValue: ArrivingHoursOptions(this.arrivingHoursList, classes)
                        }}
                      />
                    </div>
                  </label>
                  }
                  <LoyaltyForm classes={classes} />

                  <div
                    className={classes.containerInfoTrip}>
                    <div className={classes.inputBox}>
                    <RichText
                      text={'_%¿Cuál es el motivo de tu viaje?%_'}
                      translate={true}
                      ucFirst={false}
                        innerStyle={ ['roboto13Black', classes.travelReasonContainer] }
                    />
                    <RadioGroupField
                      defaultValue={reservation.getIn(['customer', 'travel_reason'], false)}
                      model={'travel_reason'}
                        innerStyle={[classes.inputRadio]}
                      options={[
                        {
                          value: 'leisure',
                          text: 'ocio',
                          translate: true,
                          ucFirst: true,
                            innerStyle: ['roboto13Black']
                        },
                        {
                          value: 'business',
                          text: 'negocio',
                          translate: true,
                          ucFirst: true,
                            innerStyle: ['roboto13Black']
                        }
                      ]}
                    />
                  </div>
                    {managementGroupID === PROPERTY_MANAGEMENT_GROUP &&
                      <div className={classes.inputBox}>
                        <label className={[classes.checkBox, classes.oblig].join(' ')} ref={'required_policies'} onChange={this.toggleBookerGuest} >
                          <CheckboxField
                            defaultValue={this.state.showBookerGuestForm}
                            type={'checkbox'}
                            model={'booker_check'}
                            innerStyle={['inputCheck', classes.inputCheck]}
                            css={{ invalid: null, valid: null }}
                            id={'td-d3-booker-form-00'}
                          />
                          <RichText
                            text={'_%La reserva es para otra persona%_'}
                            translate={true}
                            ucFirst={false}
                            innerStyle={['roboto13Black', classes.travelReasonContainer]}
                          />
                        </label>
                </div>
                    }
                  </div>
                </div>
                {this.state.showBookerGuestForm && (
                  <><div className={classes.guestFormTitle}>
                    <RichText innerStyle={[classes.title, classes.noPadding]} ucFirst={true} text={'_%datos huésped%_'} translate={true} />
                  </div><div className={classes.guestForm}>
                      <label className={classes.inputBox} ref={'booker_name'}>
                        <InputField
                          model={'booker_name'}
                          defaultValue={reservation.getIn(['customer', 'guest_booker','booker_name'], '')}
                          innerStyle={['inputText', classes.inputText]}
                          autoFocus={true}
                          validationsFields={{ field: 'nombre' }}
                          validations={[
                            'required',
                            { type: 'maxLength', maxLength: 100 },
                            { type: 'minLength', minLength: 2 }
                          ]} />
                        <InputNotify model={'booker_name'} />
                        <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%nombre%_'} translate={true} />
                      </label>
                      <label className={classes.inputBox} ref={'booker_surname'}>
                        <InputField
                          model={'booker_surname'}
                          defaultValue={reservation.getIn(['customer', 'guest_booker','booker_surname'], '')}
                          innerStyle={['inputText', classes.inputText]}
                          validationsFields={{ field: 'apellidos' }}
                          validations={[
                            'required',
                            { type: 'minLength', minLength: 2 },
                            { type: 'maxLength', maxLength: 100 }
                          ]} />
                        <InputNotify model={'booker_surname'} />
                        <RichText innerStyle={[classes.labelText, 'capitalize']} text={isUsDomain() ? '_%last_name%_' : '_%apellidos%_'}
                          translate={true} />
                      </label>
                      <label className={classes.inputBox} ref={'booker_email'}>
                        <InputField
                          model={'booker_email'}
                          defaultValue={reservation.getIn(['customer', 'guest_booker','booker_email'], '')}
                          innerStyle={['inputText', classes.inputText]}
                          validationsFields={{ field: 'email' }}
                          validations={[
                            'required',
                            'email',
                            {
                              type: 'compareField',
                              invalidText: '',
                              alterModel: 'booker_repeat_email',
                              alterField: 'repetir email'
                            }
                          ]}
                          type={'email'} />
                        <InputNotify model={'booker_email'} />
                        <RichText
                          innerStyle={[classes.labelText]}
                          ucFirst={true}
                          text={'_%email%_'}
                          translate={true} />
                      </label>
                      <label className={classes.inputBox} ref={'booker_repeat_email'}>
                        <InputField
                          model={'booker_repeat_email'}
                          defaultValue={reservation.getIn(['customer', 'guest_booker','booker_email'], '')}
                          innerStyle={['inputText', classes.inputText]}
                          validationsFields={{ field: 'repetir email' }}
                          validations={[
                            'required',
                            'email',
                            {
                              type: 'compareField',
                              alterModel: 'booker_email',
                              alterField: 'email'
                            }
                          ]}
                          type={'email'} />
                        <InputNotify model={'booker_repeat_email'} />
                        <RichText
                          innerStyle={[classes.labelText]}
                          ucFirst={true}
                          text={'_%repetir email%_'}
                          translate={true} />
                      </label>
                    </div></>
                )}

		{/*START PAYMENTFORMS*/}
                {fullFreeReservation && directPayment ? null :
                  <div className={showTpvForm || acceptPayLinks ? classes.paymentMethod : classes.hide}>
                    <RichText ucFirst={true} innerStyle={[classes.title, classes.noPadding]} translate={true}>
                      _%datos de pago%_
                    </RichText>
                    {hotelCountry === 'US' && managementGroupID === PROPERTY_MANAGEMENT_GROUP &&
                      <div className={this.tpvEnabled ? classes.cardImagesBoxTPV : classes.cardImagesBox}>
                        <Image alt={'mastercard_card_logo'} className={classes.cardLogo}
                               src={'/assets/images/mastercard_logo.png'} />
                        <Image alt={'visa_card_logo'} className={classes.cardLogo}
                               src={'/assets/images/visa_logo.png'} />
                        <Image alt={'american_express_card_logo'} className={classes.cardLogo}
                               src={'/assets/images/american_express_logo.png'} />
                        <Image alt={'diners_club_card_logo'} className={classes.cardLogo}
                               src={'/assets/images/diners_club_logo.png'} />
                        <Image alt={'union_pay_card_logo'} className={classes.cardLogo}
                               src={'/assets/images/union_pay_logo.png'} />
                      </div>}
                    <SelectPayForm
                      defaultValue={alternativePayform ? alternativePayform : reservationPayformCode}
                      reservationPaid={reservationPaid}
                      isBlackListed={blacklistedEmail}
                    />
                  </div>}
                {isNemuru && (
                  <NemuruCheckout
                    nemuru={this.Nemuru}
                    hotel={hotel}
                    reservation={reservation}
                  />
                )}
                {
                  <EPGContainer
                    tpvEnabled={this.tpvEnabled ? this.tpvEnabled : ((this.tpvApplePay || this.tpvBizumEpg)?'EPG':false)}
                    epgCashierContainer={this.EPG ? this.EPG.cashierContainer : null}
                    epgPrepayToken={this.EPG ? this.EPG.prepayToken : null}
                    payFormSelected={this.state.payFormSelected}
                    reservationPaid={reservationPaid}
                    UserLoggedST={UserLoggedST}
                  />
                }
                {this.amazonPayEnabled && <AmazonPayWidget
                  payFormSelected={this.state.payFormSelected}
                  setAmazonReferenceId={this.setAmazonReferenceId}
                />}

				        {(fullFreeReservation || this.STRIPE || isApplePay || isBizum || reservation.getIn(['payment', 'payform_code'], false) === 'paylink') ? null : <div
					        style={{ height: (parseInt(this.state.pciIframeHeight) + 30) + 'px' }}
					        className={
					        (payFormsWithPCI.includes(this.state.payFormSelected) || this.SIBS || this.BEE2PAY || (UserLoggedST && !["paypal","bizum","apple"].includes(this.state.payFormSelected))) && !reservationPaid ? classes.wrapperPciFrame : classes.hide
                  }>
                  <PciFrame
                    langCode={langCode}
                    trackingId={trackingId}
                    hotelCode={hotelCode}
                    checkinPCI={checkinPCI}
                    checkoutPCI={checkoutPCI}
                    showCVC={showCVC}
                    cfees15d={cfees15d}
                    tpvEnabled={hotel.getIn(['tpv', 'name'], false)}
                    withCof={PSD2Active}
                    requiredPrepayment={requiredPrepaymentCalc}
                    cardTokenId={this.paymentToken}
                    setRef={this.setPciFrameRef}
                    cardVerification={hotel.getIn(['pci', 'card_verification'], false)}
                  />
                </div>}

                {(!fullFreeReservation && isStripeHtl) ?  <div  className={
                  payFormsWithPCI.includes(this.state.payFormSelected) && !reservationPaid ? classes.cardHolderContainer : classes.hide
                }>

                  <div>
                    <RichText innerStyle={[classes.title,classes.promotionalCodeTitle]} translate={true} ucFirst={true}>
                      {'_%nombre del titular%_'}
                    </RichText>
                    <div>
                      <label className={classes.inputBox} ref={'card_holder'}>
                        <InputField
                          model={'card_holder'}
                          defaultValue={reservation.getIn(['customer', 'card_holder'], '')}
                          innerStyle={['inputText', classes.inputText]}
                        />
                        {!this.state.cardHolderError.error && (
                          <InputNotify model={'card_holder'}/>
                        )}
                        {this.state.cardHolderError.error && (
                          <RichText translate={true} ucFirst={true} innerStyle={[classes.promotionCodeError]} text={this.state.cardHolderError.text}/>
                        )}
                        <RichText innerStyle={[classes.labelTextTitle]} text={'_%nombre del titular%_'} ucFirst={true} translate={true}/>
                      </label>
                    </div>
                  </div>
                </div> : null}

                {(!fullFreeReservation && isStripeHtl && stripeToken) ?  <div  className={
                  payFormsWithPCI.includes(this.state.payFormSelected) && !reservationPaid ? classes.wrapperPciFrame : classes.hide
                }>
                  <Elements
                    key={stripeOptions?.clientSecret}
                    stripe={stripePromise}
                    options={stripeOptions}>
                    <StripeFrame
                      callbackRegister={this.paymentCallbackRegister}
                      hotelId={hotelId}
                      tracking={trackingId}
                      hotelCode={hotelCode}/>
                  </Elements>
                </div> : null}

                {this.state.showCardValidationError && (
                  <div className={classes.errorPCI} ref={'card_validation_error'}>
                    <RichText
                      text={
                        '_%ha ocurrido un error con tu tarjeta. Comprueba que los datos introducidos sean correctos.%_'
                      }
                      translate={true}
                      innerStyle={['errorForm15']}
                      ucFirst={true}
                    />
                  </div>
                )}


                {/*END PAYMENTFORMS*/}

                {showInvoiceForm && (
                  <div className={classes.commentSection}>
                    <div className={""}>
                      <div className={classes.invoiceToggleRow} onChange={this.toggleInvoiceData}>
                        <RichText 
                          ucFirst={true} 
                          innerStyle={[
                            classes.title,
                             classes.noPadding,
                             classes.noMargin,
                             classes.invoiceToggleLabel
                            ]}
                          translate={true} 
                          text={"_%solicitar factura de esta compra%_"}/>
                        <ToggleCheckbox
                          defaultValue={this.state.showInvoiceData}
                          model={'invoice_check'}
                          css={{ invalid: null, valid: null }}
                        />
                      </div>
                    </div>
                    {this.state.showInvoiceData && (
                      <div className={classes.invoiceForm}>
                        <div className={classes.invoiceRow}>
                          <label className={classes.inputBox} ref={'invoice_name'}>
                            <InputField
                              model={'invoice_name'}
                              defaultValue={invoiceData.get('name', '')}
                              innerStyle={['inputText', classes.inputText]}
                              validationsFields={{ field: 'nombre / razón social' }}
                              validations={[
                                'required',
                                { type: 'minLength', minLength: 2 },
                                { type: 'maxLength', maxLength: 100 }
                              ]}
                            />
                            <InputNotify model={'invoice_name'} />
                            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%nombre / razón social%_'} translate={true} />
                          </label>
                        </div>
                        <div className={classes.invoiceRow}>
                          <label className={classes.inputBox} ref={'invoice_address'}>
                            <InputField
                              model={'invoice_address'}
                              defaultValue={invoiceData.get('address', '')}
                              innerStyle={['inputText', classes.inputText]}
                              type={'text'}
                              validationsFields={{ field: 'dirección' }}
                              validations={[
                                'required',
                                { type: 'minLength', minLength: 2 },
                                { type: 'maxLength', maxLength: 100 }
                              ]}
                            />
                            <InputNotify model={'invoice_address'} />
                            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%dirección%_'} translate={true} />
                          </label>
                        </div>
                        <div className={[classes.invoiceGridRow, classes.invoiceRowInlineMobile].join(' ')}>
                          <label className={classes.inputBox} ref={'invoice_city'}>
                            <InputField
                              model={'invoice_city'}
                              defaultValue={invoiceData.get('city', '')}
                              innerStyle={['inputText', classes.inputText]}
                              type={'text'}
                              validationsFields={{ field: 'ciudad' }}
                              validations={[
                                'required',
                                { type: 'minLength', minLength: 2 },
                                { type: 'maxLength', maxLength: 100 }
                              ]}
                            />
                            <InputNotify model={'invoice_city'} />
                            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%ciudad%_'} translate={true} />
                          </label>
                          <label className={classes.inputBox} ref={'invoice_postCode'}>
                            <InputField
                              model={'invoice_postCode'}
                              defaultValue={invoiceData.get('postCode', '')}
                              innerStyle={['inputText', classes.inputText]}
                              type={'text'}
                              validationsFields={{ field: 'código postal' }}
                              validations={[
                                'required',
                                { type: 'minLength', minLength: 2 },
                                { type: 'maxLength', maxLength: 100 }
                              ]}
                            />
                            <InputNotify model={'invoice_postCode'} />
                            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%código postal%_'} translate={true} />
                          </label>
                          <label className={classes.inputBox} ref={'invoice_country'}>
                            <RichText innerStyle={[classes.countryLabel, classes.labelText]} ucFirst={true} text={'_%país%_'} translate={true} />
                            <div className={[classes.selectBox, classes.countryContainer].join(' ')}>
                              <SelectField
                                verifyInListSelected={true}
                                getOptionLabel={option => option.get('name')}
                                getOptionValue={option => option.get('alpha2')}
                                model={'invoice_country'}
                                placeholder={''}
                                innerStyle={[classes.nationalitySelector]}
                                defaultValue={invoiceDefaultCountry}
                                options={countries}
                                validations={['required', invoiceTaxValidation]}
                                styles={stylesforSelect}
                                menuPortalTarget={document.body}
                              />
                            </div>
                            <InputNotify model={'invoice_country'} />
                          </label>
                        </div>
                        <div className={[classes.invoiceGridRow, classes.invoiceRowInlineMobile].join(' ')}>
                          {invoiceIsSpain ? (
                            <label className={[classes.inputBox, classes.flexGrowSmall].join(' ')} ref={'invoice_document_type'}>
                              <RichText innerStyle={[classes.countryLabel, classes.labelText]} ucFirst={true} text={'_%tipo de documento%_'} translate={true} />
                              <div className={[classes.selectBox, classes.countryContainer].join(' ')}>
                                <SelectField
                                  verifyInListSelected={true}
                                  getOptionLabel={option => option.value}
                                  getOptionValue={option => option.value}
                                  model={'invoice_document_type'}
                                  placeholder={''}
                                  innerStyle={[classes.nationalitySelector]}
                                  defaultValue={invoiceDefaultDocType}
                                  options={INVOICE_DOCUMENT_TYPES}
                                  validations={['required', invoiceTaxValidation]}
                                  styles={stylesforSelect}
                                  menuPortalTarget={document.body}
                                />
                              </div>
                              <InputNotify model={'invoice_document_type'} />
                            </label>
                          ) : (
                            <label className={[classes.inputBox, classes.flexGrowSmall].join(' ')} ref={'invoice_document_type_free'}>
                              <InputField
                                model={'invoice_document_type_free'}
                                defaultValue={invoiceData.get('document_type', '')}
                                innerStyle={['inputText', classes.inputText]}
                                type={'text'}
                                validationsFields={{ field: 'tipo de documento' }}
                                validations={[
                                  'required',
                                  { type: 'maxLength', maxLength: 100 }
                                ]}
                              />
                              <InputNotify model={'invoice_document_type_free'} />
                              <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%tipo de documento%_'} translate={true} />
                            </label>
                          )}
                          <label className={[classes.inputBox, classes.flexGrowLarge].join(' ')} ref={'invoice_tax_number'}>
                            <InputField
                              model={'invoice_tax_number'}
                              defaultValue={invoiceData.get('tax_number', '')}
                              innerStyle={['inputText', classes.inputText]}
                              validationsFields={{ field: 'número del documento' }}
                              validations={['required', invoiceTaxValidation]}
                            />
                            <InputNotify model={'invoice_tax_number'} />
                            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%número del documento%_'} translate={true} />
                          </label>
                        </div>
                        <div className={classes.invoiceRow}>
                          <label className={classes.inputBox} ref={'invoice_email'}>
                            <InputField
                              model={'invoice_email'}
                              defaultValue={invoiceData.get('email', '')}
                              innerStyle={['inputText', classes.inputText]}
                              validationsFields={{ field: 'email' }}
                              validations={['required', 'email']}
                              type={'email'}
                            />
                            <InputNotify model={'invoice_email'} />
                            <RichText innerStyle={[classes.labelText]} ucFirst={true} text={'_%email para envío de la factura%_'} translate={true} />
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                )}


                <div className={classes.commentSection}>
                  <div className={classes.relativeFoldContainer}>
                    <RichText ucFirst={true} innerStyle={[classes.title, classes.noPadding, classes.noMargin]}
                              translate={true}>
                      _%Comentario o petición (opcional)%_
                    </RichText>
                    <Button
                      innerStyle={[classes.roomToggle, this.state.editCommentary ? classes.up : classes.down]}
                      onClick={this.toggleAdditionalCommentary}
                      ariaLabel={'_%Comentario o petición (opcional)%_'}
                      translate={true}
                      rightIcon={{
                        unicodeContent: 'E052',
                        innerStyle: [classes.searchOptionsButtonIconOpen, this.state.editCommentary ? classes.up : classes.down]
                      }}
                    />
                  </div>
                  <div ref={this.setInnerRef} className={classes.relativeFoldCommentaryAnimation}
                      onTransitionEnd={() => this.updateAfterTransition()}
                      style={{ height: this.state.heightContainer }}>
                    <div className={classes.relativeFoldCommentaryContainer}>
                      {hotelPreferences && !!hotelPreferences.size && (
                        <RoomPreferences
                          blocks={blocks}
                          sections={sections}
                          rooms={reservation.get('rooms')}
                          hotelPreferences={hotelPreferences}
                          showRoomPreferences={this.state.showRoomPreferences}
                          langCode={langCode}
                          toggleRoomPreferences={this.toggleRoomPreferences}
                          onChange={this.onChange}
                          onBlur={this.onBlur}
                        />
                      )}
                      <label className={[classes.inputBox, classes.textAreaBox].join(' ')}>
                        <div className={classes.containerAreaComment}>
                          <TextAreaField
                            model={'notes'}
                            innerStyle={[classes.inputText]}
                            defaultValue={reservation.getIn(['customer', 'notes'], '')}
                          />
                          <RichText
                            ucFirst={true}
                            innerStyle={[classes.labelText]}
                            text={'_%añadir comentarios%_'}
                            translate={true}
                          />
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                {!(hidePromotionCode && !gift_voucher) ?
                  <div className={classes.promotionCodContainer}>
                    <div className={classes.relativeFoldContainer}>
                      <RichText ucFirst={true} innerStyle={[classes.title, classes.noPadding, classes.noMargin]}
                                translate={true}>
                        _%Añadir cupón%_
                      </RichText>
                      <Button
                        innerStyle={[classes.roomToggle, this.state.showPromotionalBox ? classes.up : classes.down]}
                        onClick={this.togglePromotionalCode}
                        ariaLabel={'_%Añadir cupón%_'}
                        translate={true}
                        rightIcon={{
                          unicodeContent: 'E052',
                          innerStyle: [classes.searchOptionsButtonIconOpen, this.state.showPromotionalBox ? classes.up : classes.down]
                        }}
                      />
                    </div>
                    <CSSTransition
                      in={this.state.showPromotionalBox}
                      timeout={290}
                      classNames={{
                        enter: classes.promotionalCodeEnter,
                        enterActive: classes.promotionalCodeEnterActive,
                        exit: classes.promotionalCodeLeave,
                        exitActive: classes.promotionalCodeLeaveActive
                      }}>
                      {state => (
                        <div
                          //onClick={e => e.stopPropagation()}
                          style={state === 'exited' ? {
                            visibility: 'hidden',
                            opacity: '0',
                            height: '0',
                            paddingBottom: '0',
                            overflow: 'hidden'
                          } : { visibility: 'visible', opacity: '1' }}
                          className={[classes.promotionalCodeContainer].join(' ')}>
                          <div className={classes.promotionalCodeOverflow}>
                            {hidePromotionCode ? '' : <PromotionCodeForm type={'promotion_code'}/>}
                            {gift_voucher ? <PromotionCodeForm type={'gift_voucher'}/> : ''}
                          </div>
                        </div>
                      )}
                    </CSSTransition>
                  </div>
                  : ''
                }
                {this.travelClubEnabled && ipTravelClub?
                  <div className={classes.travelClubContainer}>
                    <div className={classes.commentSection}>
                      <RichText ucFirst={true} innerStyle={[classes.title, classes.noPadding, classes.noMargin]} translate={true}>
                        _%Travel Club%_
                      </RichText>
                      <Button
                        innerStyle={[classes.roomToggle, this.state.showTravelClub ? classes.down: classes.up ]}
                        onClick={this.toggleTravelClub}
                        ariaLabel={'_%travel club%_'}
                        translate={true}
                        rightIcon={{
                          unicodeContent: 'E052',
                          innerStyle: [classes.searchOptionsButtonIconOpen, this.state.showTravelClub  ? classes.down : classes.up]
                        }}
                      />
                      <CSSTransition
                        in={this.state.showTravelClub}
                        timeout={290}
                        classNames={{
                          enter: classes.promotionalCodeEnter,
                         /* enterActive: classes.promotionalCodeEnterActive, */
                          /* exit: classes.promotionalCodeLeave,
                          exitActive: classes.promotionalCodeLeaveActive  */
                        }}>
                        {state => (
                          <div
                            //onClick={e => e.stopPropagation()}
                            style={state === 'entered' ? {
                              visibility: 'hidden',
                              opacity: '0',
                              height: '0',
                              paddingBottom: '0',
                              overflow: 'hidden'
                            } : { visibility: 'visible', opacity: '1' }}
                              className={[classes.travelClubCards].join(' ')}>
                            <div>
                              <RichText ucFirst={true} innerStyle={['roboto13BoldBlack', 'travelclub_text']} translate={true}>
                                _%si eres socio Travel Club, introduce los 10 últimos dígitos de tu tarjeta y acumula puntos con esta reserva.%_
                              </RichText>
                              <label className={classes.inputBox} ref={'travelclub_card'}>
                                <InputField
                                  model={'travelclub_card'}
                                  defaultValue={reservation.getIn(['travelclub', 'travelclub_card'], '')}
                                  innerStyle={['inputText', classes.inputText, 'travelclub_card']} />
                                {this.state.travelclubError.validCheck && (
                                  <InputNotify model={'travelclub_card'} />
                                )}
                                <RichText innerStyle={[classes.labelText, 'capitalize']} text={'6015470 |'} translate={true} />
                                {this.state.travelclubError.error && (
                                  <RichText translate={true} ucFirst={true} innerStyle={[classes.promotionCodeError]} text={this.state.travelclubError.text} />
                                )}
                              </label>
                            </div>
                            {ipTravelClub ?
                              <div className={classes.travelCards}>
                                <Image innerStyle={'backgroundImageBase'} backgroundImage={'../assets/images/travelclub_cards.png'} />
                              </div>
                            :
                              <div className={classes.travelClubAltLogoCont}>
                                <Image svg={'travelClubAltLogo'} alt={'travel club'} innerStyle={classes.travelClubAltLogo} />
                                <div className={classes.travelClubTextContainer}>
                                  <RichText text={'_%acumula puntos%_'} innerStyle={['roboto13Gray']} ucFirst={true} translate={true} />
                                  <span className={classes.travelClubText}>travel<RichText text={'_%club%_'} innerStyle={['roboto14Gray']} ucFirst={true} translate={true} /></span>
                                </div>
                              </div>
                            }
                          </div>
                        )}
                      </CSSTransition>
                    </div>
                  </div> : ''
                }
                <LoyaltyPaymentPoints />
                <div className={classes.acceptBoxes}>
                  <LoyaltyPoliciesChecks
                    classes={classes}
                    group={hotel.get('group', '')}
                    penalties={penalties}
                    requiredPrepaymentText={requiredPrepaymentText}
                  />
                  <label className={[classes.checkBox, classes.oblig].join(' ')} ref={'required_policies'}>
                    <CheckboxField
                      defaultValue={reservation.getIn(['customer', 'required_policies'], false)}
                      type={'checkbox'}
                      validations={['required']}
                      validationsFields={{ field: '' }}
                      model={'required_policies'}
                      innerStyle={['inputCheck', classes.inputCheck]}
                      css={{ invalid: null, valid: null }}
                      ariaLabel={'_%acepto las condiciones de tarifa%_'}
                    />
                    <PolicyModalGroup group={hotel.get('group', '')} penalties={penalties} requiredPrepaymentText={requiredPrepaymentText}/>

                  </label>
                </div>
                {dataControllerText && <div className={classes.legalTextContainer}>
                  <RichText dangerouslySetInnerHTML={dataControllerText} innerStyle={['roboto11Black400']} ucFirst={true}/>
                </div>}
                <div className={classes.finalPrice}>
                  <div className={classes.tableContainer}>
                    <div className={classes.tableCell}  tabIndex={0}>
                      <RichText
                        text={summaryPriceBreakdown || showTaxes && !(isUsDomain() && taxes.nonIncluded.length > 0) ? '_%precio total%_' : '_%precio subtotal%_'}
                        innerStyle={['totalPrice']}
                        ucFirst={true}
                        translate={true}
                      />
                      <TaxIncluded showTaxes={showTaxes}/>
                    </div>
                    <div className={classes.tableCell} tabIndex={0}>
                      <OldPrice amount={totalPrice} discountPercent={discountPercent} discountAmount={discountAmount}/>
                      <Price innerStyle={['summaryPriceBig']} amount={round(endTotalPrice)}/>
                      <EquivalentPrice
                        hotelCurrencyCode={hotelCurrencyCode}
                        currentCurrencyCode={currentCurrencyCode}
                        totalPrice={round(summaryPriceBreakdown ? endTotalPrice : amountToPay)}
                        altCurrency={altCurrency}
                      />
                    </div>
                    <div className={classes.buttonContainer}>
                      {((!payformsWithOwnButton.includes(this.state.payFormSelected) || ['Redsys'].includes(this.tpvEnabled))
                          || reservationPaid) &&
                      <ButtonSubmit
                        id={this.GtmId}
                        richText={{
                          text: '_%confirmar reserva%_',
                          translate: true,
                          ucFirst: true,
                          innerStyle: ['toggleSecondButton', 'notClickable'],
                          rightIcon: {
                            unicodeContent: config.langCode === 'AR' ? '005C' : 'e000',
                            innerStyle: ['size12', 'absoluteButton', 'notClickable']
                          }
                        }}
                        innerStyle={['toggleSecondButton', classes.robotoBtn]}
                      />}
                      {this.amazonPayEnabled && <AmazonPayButton
                        reservationPaid={reservationPaid}
                        payFormSelected={this.state.payFormSelected}
                        langCode={this.props.config.langCode.toLowerCase()}
                      />}
                      {this.payPalEnabled && <PayPalContainer
                        payFormSelected={this.state.payFormSelected}
                        PayPal={this.PayPal}
                        setPayPalOrderId={this.setPayPalOrderId}
                        showErrorNotification={showErrorNotification}
                        langCode={langCode}
                        reservationPaid={reservationPaid}
                      />}

                      {
                        isStripeGooglePay && stripeToken && <Elements
                          key={stripeOptions?.clientSecret}
                          stripe={stripePromise}
                          options={stripeOptions}
                        >
                          <StripeGooglePay
                            validForm={this.validForm}
                            payFormSelected={this.state.payFormSelected}
                            stripeOptions={stripeOptions}
                            hotelId={hotelId}
                            tracking={trackingId}
                            hotelCode={hotelCode}
                          />
                        </Elements>
                      }

                    </div>
                  </div>
                </div>
                {(cityTaxValue || cityTax) &&
                  <div className={classes.taxesContainer}>
                    {theme.width >=901 &&
                      <RichText dangerouslySetInnerHTML={cityTax} innerStyle={['roboto11Black400']}/>
                    }
                    {/* here taxes for mobile */}
                    { theme.width <= 900 &&
                      <div className={classes.containerTaxesInForm}>
                        {theme.width <= 900 && (mobileNonIncludedTaxes.length > 0 || !!hotel.get('city_tax')) &&
                          <AvailMainSideSummaryTaxes
                            taxes={mobileNonIncludedTaxes}
                            included={false}
                            title={((['customerForm', 'confirmation'].includes(stepCode) && mobileNonIncludedTaxes.length > 0) || !!hotel.get('city_tax')) ? '_%información sobre impuestos%_' : null}
                            cityTax={hotel.get('city_tax')}
                            summaryPriceBreakdown={summaryPriceBreakdown}
                          />
                        }
                      </div>
                    }
                  </div>
                }
                {theme.width <= 900 && managementGroupID === PROPERTY_MANAGEMENT_GROUP &&
                  <div className={classes.hotelFiscalInfo}>
                    <AvailMainSideSummaryHotelInfo/>
                  </div>
                 }
                {legalText && <div className={classes.legalTextContainer}>
                  <RichText dangerouslySetInnerHTML={legalText} innerStyle={['roboto11Black400']}/>
                </div>}
              </Form>
            </div>

          </div>
          <div className={classes.summaryContainer}>
            <AvailMainSideSummary forceHideRedeemPoints={this.state.showBookerGuestForm}/>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
};

const mapDispatchToProps = (dispatch, ownProps, state) => {
  const { reservation } = ownProps;
  return {
    saveCustomerData: (validForm, inputList,model,showBookerGuestForm) => {
        var requiredFields = ['email', 'repeatEmail'];
        if(showBookerGuestForm) requiredFields.push('booker_email');

        return dispatch(customerActions.reservation.patchAsync(customerPatchFields, inputList, { extraFields: true, requiredFields: requiredFields }));
    },
    changeRoomPreferences: (blockIdx, inputList) => {
      dispatch(customerActions.reservation.patchAsync('preferences', inputList, { blockIdx, callbackByField: false }));
    },
    changePayForm: (validForm, inputList, tpvCode, extraParams, paymentToken) => {
      let paymentObj = {};
      if (tpvCode) {
        paymentObj = Object.assign(paymentObj, { tpvCode: tpvCode });
      }
      if (extraParams) {
        paymentObj = Object.assign(paymentObj, extraParams);
      }
      if (paymentToken) {
        paymentObj = Object.assign(paymentObj, { paymentToken: paymentToken });
      }
      return dispatch(customerActions.reservation.patchAsync('payment', inputList, paymentObj));
      //  }
    },
    confirmBooking: (inputList, paymentToken, amountPaid) => {
      //validació per si les mosques, no hauria de ser necessari

      const validationFields = ['email', 'repeatEmail'];
      if (
        validationFields.every(field => inputList[field] && inputList[field].validation.valid && inputList[field].value)
      ) {
        return dispatch(
          customerActions.reservation.patchAsync(bookingPatchFields, inputList, {
            paymentToken,
            extraFields: true,
            fromSuccessCof: true,
            payed : !!amountPaid
          })
        ).catch((e) => {
          if (e.name === 409) {
            dispatch(actions.avail.resetAvail());
            dispatch(actions.availServices.resetAvail());
            dispatch(actions.customer.step.change('monoHotelAvail'));
            dispatch(actions.router.update(true));
          }
        });
      } else {
        return Promise.reject();
      }
    },
    confirmBookingOnlyStore: () => {
      dispatch(customerActions.reservation.set(reservation.set('status', 'confirmed')));
    },
    incrementPaymentRetry: (nRetry) => {
      dispatch(customerActions.reservation.set(reservation.setIn(['payment', 'n_retry'], nRetry)));
    },

    confirmBookingTPV: (inputList, payed, hotelId, trackingId, tpvId, tpvCode, paymentToken, nRetry) => {
      const { loyaltyUser, loyaltyType } = ownProps;
      const UserLoggedST = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;
      //validació per si les mosques, no hauria de ser necessari
      const validationFields = ['email', 'repeatEmail'];
      if (
        validationFields.every(
          field => inputList[field] && inputList[field].validation.valid && inputList[field].value
        ) &&
        reservation.get('tracking_id') === trackingId
      ) {
        let patchObj = {
          payed: payed,
          tpvId: tpvId,
          tpvCode: tpvCode,
          extraFields: true
        };
        if(!UserLoggedST) {

          patchObj.merchantTransactionId = `${hotelId}-${trackingId}` + (nRetry ? `-${nRetry}` : '');
        if(nRetry) {
          patchObj.TPVnRetry = nRetry;
        }
        }
        if(paymentToken) {
          patchObj.paymentToken = paymentToken;
        }
        return dispatch(
          customerActions.reservation.patchAsync(bookingPatchFields, inputList, patchObj)
        );
      } else {
        return Promise.reject();
      }
    },
    cancelBooking: (inputList) => {
      return dispatch(customerActions.reservation.patchAsync(bookingPatchFields, inputList, { cancelReservation: true }));
    },
    showConfirmation: (reservation, hotel) => {
      //dispatch(actions.events.trigger('confirm_customer_data'));
      dispatch(actions.customer.step.next());
      dispatch(actions.router.update());
      return true;
    },
    showErrorNotification: text => {
      dispatch(actions.notifications.send('error', text));
      window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
    },
    setReservationPayed: (reservation, showTaxes) => {
      dispatch(
        customerActions.reservation.set(
          reservation
            .set('status', 'confirmed')
            .setIn(['payment', 'state'], 'payed')
            .setIn(['payment', 'amount_paid'], reservation.get(showTaxes ? 'total_price_tax' : 'total_price'))
            .setIn(['payment', 'amount_pending'], 0)
        )
      );
      return true;
    },
    setReservationToken: (reservation, token) => {
      dispatch(
        customerActions.reservation.set(reservation.setIn(['payment', 'token'], token))
      );
      return true;
    },
    triggerEvent: (name, error) => {
      dispatch(actions.events.trigger(name, { error }));
    },
    triggerFormEmailEvent: (email) => {
      dispatch(actions.events.trigger('form_email', { email }));
    },
    triggerEventHasStoredCards: (name, hasStoredCards, newSelectedPayform, pciFrameLoaded) => {
      dispatch(actions.events.trigger(name, { hasStoredCards, newSelectedPayform, pciFrameLoaded } ));
    },
    hideAvailEngine: () => {
      dispatch(customerActions.header.show('engine', false));
    },
    setStripeToken: (currency, lang, price, hotelCode, trackingId, redirectUrl,force = false, payform_code = 'htl') => {
      dispatch(customerActions.stripeToken.getAsync(currency, lang, price, hotelCode, trackingId, redirectUrl, force, payform_code));
      return true;
    },
    setPayformOP: (inputList) => {
      dispatch(
        customerActions.reservation.patchAsync('payment', inputList, {
          forcePayformOP : true
        })
      );
      dispatch(customerActions.reservation.set(reservation.setIn(['payment', 'payform_code'], 'op')));
      return true;
    },
    loyaltyRegister: (inputList) => {
      return dispatch(
        actions.customer.loyalty.register(inputList)
      );
    },
    loyaltyLogin: (inputList) => {
      dispatch(
        actions.customer.loyalty.login(inputList)
      );
      return true;
    },
    refreshBlockPoints : () => {
      return dispatch(actions.customer.loyalty.refreshBlockPointsAsync());
    },
    setBookingTms : () => {
      return dispatch(actions.customer.loyalty.setBookingTmsAsync());
    },
    deleteBookingTms : () => {
      return dispatch(actions.customer.loyalty.deleteBookingTmsAsync());
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  let hotelInfo = store.getIn(['hotels', hotelId]);
  hotelInfo = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;
  const loyaltyRoomsAvail = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'loyalty_query_params']),
    'response'
  ],false);
  const roomRatesSelected = store.getIn(['customer', 'reservation_request']);
  const reservation = store.getIn(['customer', 'reservation']);
  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks']);
  const queryParams = store.getIn(['hotels', hotelId, 'params', 'params']);
  const checkin = queryParams && moment(queryParams.get('date'));
  const stayLength = queryParams && queryParams.get('stay_length');
  const blocks = store.getIn(['customer', 'reservation_request', 'blocks']);
  const tpvPaymentStatus = hashSpliter(window.location.hash)[3] || false;
  const stripeStatus = hashSpliter(window.location.hash)[4] || false;
  const amountPromoPaid = reservation.getIn(['payment', 'amount_promo_paid'], 0);
  const amazonPayEnabled = hotelInfo && hotelInfo.getIn(['amazon_pay', 'name'], false);
  const amazonPayParams = amazonPayEnabled && hotelInfo && hotelInfo.getIn(['amazon_pay', 'tpv_params'], List());
  const amazonPayMerchantID = amazonPayParams && amazonPayParams.find(p => p.get('code') === 'merchant_id', Map()).get('value', '');
  const withTaxes = hotelInfo && hotelInfo.get('show_taxes', true);
  let blacklistedEmails = hotelInfo && hotelInfo.get('blacklist_emails', false);
  blacklistedEmails = blacklistedEmails && blacklistedEmails.map(emailB64 =>decodeBlackEmail(emailB64, hotelId));
  const amountTaxes = withTaxes ? reservation.get('total_price_tax', 0) : reservation.get('total_price', 0);
  const directPayment = hotelInfo && hotelInfo.getIn(['payment_info', 'direct_payment'], true);
  let fullFreeReservation = store.getIn(['customer', 'reservation', 'penalties', 0], false);
  const profileType = store.getIn(['customer', 'corporate', 'tipo_perfil'], false);
  const tpvEnabled = hotelInfo && !(hotelInfo.getIn(['tpv_only_gift_voucher'], false)) ? hotelInfo.getIn(['tpv', 'name'], false) : false;
  const loyaltyUser = store.getIn(['customer', 'loyalty','user',"user_id"], null) && store.getIn(['customer', 'loyalty','user'], null);
  const loyaltyType = store.getIn(["customer", "loyalty", "data", "loyalty", "code"],null);
  //const UserLoggedST = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;
  const totalPointsPrice = reservation?.getIn(["loyalty", "total_points_price"], 0);
  const reservationObj = store.getIn(['customer', 'reservation'], false);
  const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;
  const showTaxes = shouldShowTaxes(hotel, reservationObj) ?? true;
  const forceTaxes = hotelInfo && !hotelInfo.get('show_taxes') && showTaxes ? true : null;

  const amountToPay = amountTaxes - amountPromoPaid - totalPointsPrice;
  if (fullFreeReservation) {
    fullFreeReservation = (fullFreeReservation.get('release', null) === 23976 && fullFreeReservation.get('type', null) === 'percentage'
      && fullFreeReservation.get('value', null) === 0 && fullFreeReservation.get('show_as', null) === 'days');
  }


  const isNotFinallyConfirmed = !(
    reservation.get('status', false) === 'confirmed' &&
    !(
      (['op', 'amazon_pay'].includes(reservation.getIn(['payment', 'payform_code'], false))) &&
      reservation.getIn(['payment', 'state'], false) === 'pending'
    )
  );

  let requiredPrepayment = 0;
  let requiredPrepaymentType = false;
  let requiredPrepaymentValue = false;
  reservation && reservation.get('blocks', List()).forEach(block => {
    requiredPrepayment += block.get('required_prepayment', 0);
    if (!requiredPrepaymentType) {
      requiredPrepaymentType = block.get('required_prepayment_type', '');
      requiredPrepaymentValue = block.get('required_prepayment_value', 0);
    }
  });

  let reservationEmail = reservation.getIn(['customer', 'email'], false);
  let forceOP = false;
  if(tpvEnabled && blacklistedEmails && blacklistedEmails.includes(reservationEmail)) {
    forceOP = true;
  }

  // let promoCodeDiscount = null;
  // let promoCode;
  // let giftCode = null;
  let giftCodeDiscount = 0;
  if (amountPromoPaid > 0 && reservation.getIn(['gift_voucher', 'code'], '') !== '') {
    giftCodeDiscount = amountPromoPaid * -1;
  }
  const referer = store.getIn(['customer', 'params', 'url_params', 'referer_code'], false);
  const acceptPayLinks = store.getIn(['hotels', hotelId, 'affiliates_with_paylink'], List()).includes(referer);
  return {
    hotel: hotelInfo,
    reservation: reservation.size > 0 && isNotFinallyConfirmed ? reservation : undefined,
    reservationTotals: reservationBlocks && is(List, reservationBlocks) && reservationBlocks.size > 0 && getReservationTotals(store, forceTaxes),
    reservationTotalsBothModes: reservationBlocks && is(List, reservationBlocks) && reservationBlocks.size > 0 && getReservationTotalsBothModes(store),
    langCode: store.getIn(['customer', 'lang_info', 'code']).toUpperCase(),
    checkin: checkin,
    stayLength: stayLength,
    defaultCountryCode: store.getIn(['customer', 'currencyCountry', 'country', 'code'], 'ES'),
    hotelPreferences: cleanHotelPreferences(store.getIn(['hotels', hotelId, 'preferences'], List())),
    countries: store.get('countries'),
    blocks: blocks && !blocks.some(block => block.get('room_id', false) === false) ? blocks : undefined,
    sections: store.getIn(['customer', 'reservation', 'sections']),
    corporatePayForms: store.getIn(['customer', 'corporate', 'pay_forms'], List()),
    tpvPaymentStatus: tpvPaymentStatus,
    cfees15d: reservation.size > 0 ? hasCancellationFeesIn15Days(reservation) : false,
    showTaxes: showTaxes,
    managementGroupID: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo.get('management_group_id'),
    reservationPaid: reservation.get('total_price_tax', false) > 0 && reservation.get('total_price_tax', false) === (reservation.getIn(['payment', 'amount_promo_paid'], false) + totalPointsPrice),
    amountToPay:amountToPay,
    paymentPointsDiscount : totalPointsPrice *-1,
    gift_voucher: store.getIn(['hotels', hotelId, 'gift_voucher']) ? store.getIn(['hotels', hotelId, 'gift_voucher']) : false,
    giftCodeDiscount: giftCodeDiscount,
    amazonPayMerchantID: amazonPayMerchantID,
    directPayment: directPayment,
    fullFreeReservation: fullFreeReservation,
    referer: store.getIn(['customer', 'params', 'url_params', 'id_referer'], false),
    requiredPrepayment: requiredPrepayment,
    requiredPrepaymentType: requiredPrepaymentType,
    requiredPrepaymentValue: requiredPrepaymentValue,
    //Currencies
    currencies: store.getIn(['customer', 'currencies']),
    langInfo: store.getIn(['customer', 'lang_info']),
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
    hotelCurrencyCode: store.getIn(['hotels', hotelId, 'currency', 'code']),
    profileType: profileType,
    stripeToken: store.getIn(['customer', 'stripe_token'],false) || false,
    stripeTokenStatus: stripeStatus,
    loyaltyRoomsAvail: loyaltyRoomsAvail,
    loyaltySelected: !!loyaltyRoomsAvail && roomRatesSelected.get('loyalty', false),
    loyaltyUser: loyaltyUser,
    loyaltyType : loyaltyType,
    ipCountry: store.getIn(['customer','country_ip'],false),
    forceOP: forceOP,
    acceptPayLinks: acceptPayLinks,
    loyaltyCheckboxChecked: reservation.getIn(['customer', 'check_loyalty'], false),
    customerCountry: store.getIn(['customer','country', 'code'],false),
    blacklistedEmails,
    stepCode: store.getIn(['customer', 'step', 'current_step', 'code']),
    hotelConfig: contextualizeAppConfig(store, hotelId),
    summaryPriceBreakdown: hotel && hotel.get('summary_price_breakdown', false),
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, /*['reservation', 'blocks', 'sections','trackingId']*/[], LoadingFragment),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  showPopover,
  PropertyManager([
    'hotel',
    'blocks',
    'changePayForm',
    'changeRoomPreferences',
    'checkin',
    'confirmBooking',
    'confirmBookingOnlyStore',
    'confirmBookingTPV',
    'cancelBooking',
    'corporatePayForms',
    'countries',
    'currentCurrencyCode',
    'defaultCountryCode',
    'hotelCurrencyCode',
    'hotelPreferences',
    'langCode',
    'reservation',
    'reservationTotals',
    'reservationTotalsBothModes',
    'refreshBlockPoints',
    'setBookingTms',
    'deleteBookingTms',
    'saveCustomerData',
    'sections',
    'showConfirmation',
    'stayLength',
    'tpvPaymentStatus',
    'showErrorNotification',
    'setReservationPayed',
    'setReservationToken',
    'triggerEvent',
    'triggerEventHasStoredCards',
    'triggerFormEmailEvent',
    'cfees15d',
    'showTaxes',
    'managementGroupID',
    'hideAvailEngine',
    'reservationPaid',
    'amountToPay',
    'gift_voucher',
    'amazonPayMerchantID',
    'incrementPaymentRetry',
    'fullFreeReservation',
    'directPayment',
    'referer',
    'currencies',
    'langInfo',
    'requiredPrepayment',
    'requiredPrepaymentType',
    'requiredPrepaymentValue',
    'profileType',
    'setStripeToken',
    'stripeToken',
    'stripeTokenStatus',
    'loyaltyRoomsAvail',
    'loyaltySelected',
    'loyaltyUser',
    'loyaltyType',
    'ipCountry',
    'forceOP',
    'acceptPayLinks',
    'setPayformOP',
    'loyaltyRegister',
    'loyaltyLogin',
    'loyaltyCheckboxChecked',
    'customerCountry',
    'giftCodeDiscount',
    'closeByFamily',
    'toggleModal',
    'paymentPointsDiscount',
    'blacklistedEmails',
    'hotelConfig',
    'stepCode',
    'summaryPriceBreakdown'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent(['i18n','countryFlags'])
)(CustomerForm);
